<template>
  <div class="bgbox">
    <div class="topView" v-show="orderObj.status">
      <div class="Viewtitle">
        <div class="IImg">
          <img src="../../../assets/imgs/I.png" v-if="orderObj.status == 'I'" width="32px" height="48px" alt="" />
          <img src="../../../assets/imgs/C.png" v-if="orderObj.status == 'C'" width="32px" height="48px" alt="" />
          <img src="../../../assets/imgs/F.png" v-if="orderObj.status == 'F'" width="32px" height="48px" alt="" />
          <img src="../../../assets/imgs/G.png" v-if="orderObj.status == 'G'" width="32px" height="48px" alt="" />
          <img src="../../../assets/imgs/L.png" v-if="orderObj.status == 'L'" width="32px" height="48px" alt="" />
          <img src="../../../assets/imgs/O.png" v-if="orderObj.status == 'O'" width="32px" height="48px" alt="" />
          <img src="../../../assets/imgs/S.png" v-if="orderObj.status == 'S'" width="32px" height="48px" alt="" />
        </div>

        <!-- <div>台号: {{ orderObj.mealTableNum }}</div>
          <div>人数:{{ orderObj.peopleCount }}</div> -->

        <div style="display: flex; align-items: center; height: 100%">
          <el-checkbox v-model="twchecked" @change="sureTwchecked">批量选菜</el-checkbox>
          <el-tooltip class="item" effect="light" content="勾选多选后，支持批量冲菜和转菜。" placement="bottom">
            <img src="../../../assets/imgs/ask.png" width="22px" height="22px" style="margin: 0 0px 5px 10px; cursor: pointer" alt="" />
          </el-tooltip>
        </div>
        <div>单号：{{ orderObj ? orderObj.orderNum : '' }}</div>
        <div>开单：{{ orderObj ? orderObj.userName + '/' + orderObj.orderTime : '' }}</div>

        <div style="display: flex; align-items: center">
          <div>
            合计：
            <span style="color: #e74c3c; font-size: 20px">{{ orderObj.allPrice ? orderObj.allPrice.toFixed(2) : '' }}</span>
          </div>
          <img src="../../../assets/imgs/refresh.png" v-if="orderObj.allPrice" width="20px" height="20px" style="margin: 0 0 0 10px; cursor: pointer" alt="" @click="fixAccount" />
        </div>
        <!-- <div class="allPrice">
          <div style="color: #666">合计</div>
          <div class="totalPrice"> {{ orderObj.allPrice.toFixed(2) }}元 </div> -->
        <!-- </div> -->
      </div>
      <!-- <div class="DetailsCheck">

          <el-radio-group v-model="radio1" @change="changestatus">
            <el-radio-button label="菜品详情"></el-radio-button>
            <el-radio-button v-if="routeStatus == 0" label="餐单详情"></el-radio-button>
            <el-radio-button v-if="routeStatus == 1" label="结账明细"></el-radio-button>
          </el-radio-group>
        </div> -->
    </div>
    <div class="rightOrder" :style="orderObj.status ? 'height: calc(100% - 66px)' : 'height: 100% '">
      <div class="bigbox">
        <div class="mainView" :class="orderMenus.length ? '' : 'mainViews'">
          <div class="hiddenTips" v-if="$store.state.routePath == 0 && !orderObj.mealTableNum">
            <div class="tips">
              <img src="../../../assets/imgs/left.png" alt="" style="width: 200px; height: 200px" />
              <span>请在左侧选择营业点及桌号开台</span>
            </div>
          </div>
          <div class="hiddenTips" v-if="$store.state.routePath == 1 && !orderObj.mealTableNum">
            <div class="tips">
              <img src="../../../assets/imgs/left.png" alt="" style="width: 200px; height: 200px" />
              <span>请在左侧选择日期查询餐单</span>
            </div>
          </div>
          <div class="selectTitle" v-if="orderMenus.length">
            <div>编码</div>
            <div>名称</div>
            <div>数量</div>
            <div>单位</div>
            <div style="text-align: right">原价</div>
            <div style="text-align: right">折扣</div>
            <div style="text-align: right">服务费</div>
            <div style="text-align: right">税</div>
            <div style="text-align: right">小计</div>
          </div>

          <div
            class="selectItem"
            v-for="(v, i) in orderMenus"
            :key="i"
            :class="v.funcBtnShow == 1 ? 'selectItemCurrent' : ''"
            v-if="status == 1"
            :style="{ border: itemchecked ? '1px solid #0099FF' : '', background: itemchecked ? '#EDF8FF' : '' }"
          >
            <div style="margin: 0 4px" v-if="twchecked">
              <el-checkbox v-model="v.itemchecked" @change="itemcheckedChange($event, v, i)"></el-checkbox>
            </div>

            <div style="width: 100%">
              <div class="selectTop" @click="checkItem(v, i)" :class="twchecked ? 'dontClick' : ''">
                <span style="color: #666">{{ v.dishesCode }}</span>
                <div style="display: flex; align-items: center">
                  <div style="color: #666" :style="{ textDecoration: v.status == 'F' ? 'line-through red' : v.status == 'X' ? 'line-through red' : '' }">
                    {{ v.dishesName }}
                  </div>
                  <span v-if="v.discountType">
                    <el-tooltip effect="light" placement="top">
                      <div slot="content" v-if="v.discountReason">{{ v.discountReason }}</div>
                      <div slot="content" v-else>{{ v.discountRate }}折</div>
                      <div class="discountType">{{ v.discountType == 'D' ? '折' : '赠' }}</div>
                    </el-tooltip>
                  </span>
                  <span v-if="v.splitRemark">
                    <el-tooltip effect="light" placement="top">
                      <div slot="content">{{ v.splitRemark }}</div>
                      <div class="discountType" style="background: #2b88d8">分</div>
                    </el-tooltip>
                  </span>
                </div>

                <div style="color: #e74c3c">
                  <!-- <img src="../../../assets/imgs/I.png" width="20px" height="24px" style="margin-right: 10px" alt="" /> -->
                  <span>{{ parseFloat(v.quantity).toFixed(2) }}</span>
                </div>
                <div>{{ v.unitName }}</div>
                <div style="text-align: right">{{ parseFloat(v.price).toFixed(2) }}</div>
                <div style="text-align: right">-{{ parseFloat(v.discount).toFixed(2) }}</div>
                <div style="text-align: right">{{ parseFloat(v.serverPrice).toFixed(2) }}</div>
                <div style="text-align: right">{{ parseFloat(v.tax).toFixed(2) }}</div>
                <div style="text-align: right; color: #e74c3c">{{ parseFloat(v.discountPrice).toFixed(2) }}</div>
                <!-- <div class="selectNum"
                :style="{ textDecoration: v.status == 'F' ? 'line-through red' : v.status == 'X' ? 'line-through red' : '' }">
                <span style="
                text-decoration: line-through;
                color: #999999;
                font-size: 14px;
              ">￥ {{ parseFloat(v.totalPrice * 1).toFixed(2) }} </span>
                <span style="color: #fe852f; font-size: 24px">￥{{ parseFloat(v.discountPrice * 1).toFixed(2) }}</span>
              </div> -->
              </div>

              <div class="selectBottom" v-if="v.funcBtnShow" @click="checkItem(v, i)" :class="twchecked ? 'dontClick' : ''">
                <div class="selectLeftBottom">
                  <span style="margin-right: 36px">{{ v.type == 1 ? '零点' : v.type == 2 ? '计时' : '套餐' }}</span>
                  <span style="margin-right: 16px">
                    <span style="color: #fe852f">￥{{ parseFloat(v.price * 1).toFixed(2) }}</span>
                    /{{ v.unitName }}
                  </span>
                  <div style="margin-right: 15px">
                    技师:
                    {{ v.technicianName || '' }}

                    <!--  <el-select v-model="JSvalue">
                  <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select> -->
                  </div>
                  <div style="display: flex; align-items: center">
                    <div>要求:</div>
                    {{ v.remark }}
                    <!-- <el-input v-model="orderObj.remark" :placeholder="v.remark" @blur="requirementValueBlur(v)"></el-input> -->

                    <!-- <input type="text" v-model="v.remark" v-if=" v.remark"  style="width:150px;border:0;border-bottom:1px solid #eaeaea;outline:none"> -->
                    <!-- <i class="el-icon-edit" @click="v.requirement = 1" style="cursor:pointer"></i> -->
                  </div>
                </div>
                <div>点菜时间:{{ v.orderTime }}</div>
              </div>

              <div v-if="!twchecked">
                <!-- 当前选中的一列  funcBtnShow  菜单状态 status
            首页/餐单   routeStatus 今日/历史  $store.state.currentTitle 有效/所有  Effective-->
                <div class="funcBtn" v-if="v.funcBtnShow && v.status != 'F' && v.status != 'X' && routeStatus == 0">
                  <div
                    class="funcBtnItem"
                    v-for="(vv, i) in funcBtnList"
                    :key="i"
                    @click="funcBtnclickItem(vv, i, v)"
                    :class="[
                      vv == '改菜名' && !v.is_can_update_name ? 'disable' : '',
                      vv == '改价格' && !v.is_can_update_price ? 'disable' : '',
                      vv == '折扣' && v.status != 'G' && routeStatus != '0' ? 'disable' : '',
                    ]"
                  >
                    {{ vv }}
                  </div>
                </div>

                <div
                  class="funcBtn"
                  v-if="v.funcBtnShow && v.status != 'F' && routeStatus == 1 && orderObj.status != 'O' && v.status != 'C' && $store.state.currentTitle == 0 && Effective == 1 && v.status != 'X'"
                >
                  <div
                    class="funcBtnItem"
                    v-for="(vv, i) in funcBtnList"
                    :key="i"
                    @click="funcBtnclickItem(vv, i, v)"
                    :class="[
                      vv == '改菜名' && !v.is_can_update_name ? 'disable' : '',
                      vv == '改价格' && !v.is_can_update_price ? 'disable' : '',
                      vv == '折扣' && v.status != 'G' && routeStatus != '0' ? 'disable' : '',
                    ]"
                  >
                    {{ vv }}
                  </div>
                </div>

                <div
                  class="funcBtn"
                  v-if="
                    v.funcBtnShow &&
                    v.status != 'F' &&
                    routeStatus == 1 &&
                    orderObj.status != 'O' &&
                    v.status != 'L' &&
                    v.status != 'S' &&
                    v.status != 'C' &&
                    $store.state.currentTitle == 0 &&
                    Effective == 2 &&
                    v.status != 'X'
                  "
                >
                  <div
                    class="funcBtnItem"
                    v-for="(vv, i) in funcBtnList"
                    :key="i"
                    @click="funcBtnclickItem(vv, i, v)"
                    :class="[
                      vv == '改菜名' && !v.is_can_update_name ? 'disable' : '',
                      vv == '改价格' && !v.is_can_update_price ? 'disable' : '',
                      vv == '折扣' && v.status != 'G' && routeStatus != '0' ? 'disable' : '',
                    ]"
                  >
                    {{ vv }}
                  </div>
                </div>

                <div
                  class="funcBtn"
                  v-if="v.funcBtnShow && v.status != 'F' && routeStatus == 1 && orderObj.status != 'O' && v.status != 'L' && v.status != 'C' && $store.state.currentTitle == 1 && v.status != 'X'"
                >
                  <div
                    class="funcBtnItem"
                    v-for="(vv, i) in funcBtnList"
                    :key="i"
                    @click="funcBtnclickItem(vv, i, v)"
                    :class="[
                      vv == '改菜名' && !v.is_can_update_name ? 'disable' : '',
                      vv == '改价格' && !v.is_can_update_price ? 'disable' : '',
                      vv == '折扣' && v.status != 'G' && routeStatus != '0' ? 'disable' : '',
                    ]"
                  >
                    {{ vv }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 合计 -->
        <div class="footerTop" v-if="status == 1 && orderObj.mealTableNum && orderMenus.length">
          <div style="margin-left: 10px; display: flex; align-items: center; height: 100%; border-right: 1px solid #eaeaea">
            <el-radio v-model="Effective" @change="changeEFF" style="margin-right: 10px; font-size: 16px" label="1">有效</el-radio>
            <el-radio style="font-size: 16px" v-model="Effective" @change="changeEFF" label="2">所有</el-radio>
          </div>

          <div style="margin-left: 10px">{{ orderMenus.length }}条</div>
          <div v-for="(tr, i) in sums" :key="i" :style="i == 5 || i == 4 || i == 3 || i == 1 || i == 2 ? 'color: #e74c3c;text-align:right' : ''">
            {{ tr != 0 ? (i == 2 ? '-' + tr.toFixed(2) : tr.toFixed(2)) : '' }}
          </div>
        </div>

        <!-- 底部按钮栏 -->
        <!-- status 1 菜品详情  2 餐单详情 -->
        <!-- orderObj.mealTableNum 判断有没有点击选中态位 -->
        <div class="mainFooter" v-show="status == 1 && orderObj.mealTableNum">
          <div class="footerBottom" v-if="!twchecked">
            <!-- 联单 挂单销单 账单 分单 -->
            <div class="footerLeftDiv" v-if="routeStatus == 0">
              <!-- 首页 -->
              <div class="footerLeftbutton" v-if="orderObj.status != 'R'">
                <div v-for="(v, i) in bottomleftDiv" :key="i" v-if="v != '追回'" @click="bottomleftDivCLick(v, i)">{{ v }}</div>
              </div>
              <div class="footerLeftbutton" v-if="orderObj.status == 'R'">
                <div @click="Registration">登记</div>
                <div @click="cancellation">取消</div>
              </div>
            </div>

            <div class="footerLeftDiv" v-if="routeStatus == 1 && $store.state.currentTitle == 0">
              <!-- 餐单 -->

              <div class="footerLeftbutton" v-if="orderObj.status == 'C'"></div>
              <div class="footerLeftbutton" v-if="orderObj.status == 'U'">
                <div v-for="(v, i) in bottomleftDiv" :key="i" v-if="v != '追回'" :class="v == '销单' ? ' ' : 'disable'" @click="bottomleftDivCLick(v, i)">{{ v }}</div>
              </div>
              <div class="footerLeftbutton" v-if="orderObj.status == 'G'">
                <div v-for="(v, i) in bottomleftDiv" :key="i" v-if="v != '追回'" @click="bottomleftDivCLick(v, i)">{{ v }}</div>
              </div>

              <div class="footerLeftbutton" v-if="orderObj.status == 'O'">
                <div @click="bottomleftDivCLick('账单')">账单</div>
              </div>

              <div class="footerLeftbutton" v-if="orderObj.status == 'R'"></div>

              <div class="footerLeftbutton" v-if="orderObj.status == 'S'">
                <div v-for="(v, i) in bottomleftDiv" :key="i" v-if="v == '账单' || v == '追回' || v == '销单'" @click="bottomleftDivCLick(v, i)">{{ v }}</div>
              </div>

              <!-- <span style="color:#0099ff;margin-left:30px">结账明细</span> -->
            </div>

            <div class="footerLeftDiv" v-if="routeStatus == 1 && $store.state.currentTitle == 1">
              <!-- 餐单 -->
              <div class="footerLeftbutton" v-if="orderObj.status == 'C'"></div>
              <div class="footerLeftbutton" v-if="orderObj.status == 'R'"></div>

              <div class="footerLeftbutton" v-if="orderObj.status == 'G'">
                <div v-for="(v, i) in bottomleftDiv" :key="i" v-if="v != '追回'" @click="bottomleftDivCLick(v, i)">{{ v }}</div>
              </div>

              <div class="footerLeftbutton" v-if="orderObj.status == 'O'">
                <div v-for="(v, i) in bottomleftDiv" :key="i" :class="v == '账单' ? ' ' : 'disable'" v-if="v != '追回'" @click="bottomleftDivCLick(v, i)">{{ v }}</div>
              </div>
              <div class="footerLeftbutton" v-if="showReCalc">
                <div @click="reCalcOrder('账单')">刷新</div>
              </div>
              <div class="footerLeftbutton" v-if="orderObj.status == 'S'">
                <div v-for="(v, i) in bottomleftDiv" :key="i" :class="v == '账单' ? ' ' : v == '追回' ? ' ' : v == '销单' ? ' ' : 'disable'" @click="bottomleftDivCLick(v, i)">{{ v }}</div>
              </div>

              <!-- <span style="color:#0099ff;margin-left:30px">结账明细</span> -->
            </div>

            <!-- 结账点菜  -->
            <div class="footerRightDiv" v-if="routeStatus == 0 && orderObj.status != 'R'">
              <!-- 首页 -->
              <div v-for="(v, i) in bottomRightDiv" :key="i" @click="rightBtn(v, i)">
                <div class="rightBtn">
                  <div>
                    {{ v }}
                    <span v-if="v == '点菜' && rightBtnnumber">({{ rightBtnnumber }})</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="footerRightDiv" v-if="routeStatus == 1">
              <!-- 餐单 -->
              <div v-for="(v, i) in bottomRightDiv" :key="i" @click="rightBtn(v, i)" v-if="v == '结账' && dcStatus != 'O' && dcStatus != 'C'">
                <div class="rightBtn">
                  <sapn>{{ v }}</sapn>
                </div>
              </div>

              <div :class="$store.state.currentTitle == 1 ? 'grayBtn' : 'rightBtn'" v-if="dcStatus == 'O' && dcStatus != 'C'" @click="cxRefund">撤销结账</div>
            </div>
          </div>

          <div class="footerBottom" v-if="twchecked">
            <div>
              <!-- <el-checkbox v-model="twchecked" @change="sureTwchecked">全选</el-checkbox> -->
              <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
            </div>
            <div class="footerRightDiv">
              <div @click="cancelTwchecked" class="rightBtn">取消</div>
              <div @click="funcBtnclickItem('批量冲菜')" v-if="orderObj.status != 'O'" class="rightBtn">批量冲菜</div>
              <div @click="mealTableNumflags" v-if="orderObj.status != 'O'" class="rightBtn">批量转菜</div>
            </div>
          </div>
        </div>
      </div>

      <!-- //餐单查询 -->
      <div class="menuDetails">
        <div class="menuDataThreeAndFour">
          <div class="menuDataThreeAndFourItem" @click="mealTableNumflag">
            <div style="color: #999">桌号</div>

            <div style="color: #666">{{ orderObj.mealTableNum ? orderObj.mealTableNum : '...' }}</div>
          </div>
          <div class="menuDataThreeAndFourItem" @click="openPeopleDialog">
            <div style="color: #999">人数</div>
            <div style="color: #666">{{ orderObj.peopleCount ? orderObj.peopleCount : '...' }}</div>
          </div>
          <div class="menuDataThreeAndFourItem" @click="openwaiter">
            <div style="color: #999">服务员</div>
            <div style="color: #fe852f" v-if="orderObj.waiter">
              {{ orderObj.waiter ? orderObj.waiter.description : '' }}
            </div>
            <div style="color: #666" v-else>...</div>
          </div>

          <div class="menuDataThreeAndFourItem" @click="opensalesPerson">
            <div style="color: #999">销售员</div>
            <div style="color: #fe852f" v-if="orderObj.salesPerson">{{ orderObj.salesPerson.description }}</div>
            <div style="color: #666; x" v-else>...</div>
          </div>
        </div>
        <div class="menuDataOneRight" @click="openSingleCopy" v-if="orderObj.status != 'R'">
          <div style="color: #999">联单</div>
          <div style="color: #666">{{ orderObj.linkPrice ? orderObj.linkPrice.toFixed(2) : '0.00' }}</div>
        </div>
        <div class="menuDataOneRight" v-if="orderObj.status == 'R'">
          <div style="color: #999">预订姓名</div>
          <div>{{ orderObj.bookName }}</div>
        </div>
        <div class="menuDataOneRight" v-if="orderObj.status == 'R'">
          <div style="color: #999">联系人名字</div>
          <div>{{ orderObj.contactName }}</div>
        </div>
        <div class="menuDataOneRight" v-if="orderObj.status == 'R'">
          <div style="color: #999">电话</div>
          <div>{{ orderObj.contactTele }}</div>
        </div>
        <div class="menuDataOneRight" @click="openbillDialog">
          <div style="color: #999">打折模式</div>
          <div style="color: #666">{{ orderObj.discountModelName ? orderObj.discountModelName : '...' }}</div>
        </div>
        <div class="menuDataOneRight" @click="updatemenuTypeName">
          <div style="color: #999">类别</div>
          <div style="color: #666">{{ orderObj.menuTypeName ? orderObj.menuTypeName : '...' }}</div>
        </div>
        <div class="menuDataOneRight" @click="openuserflag">
          <div style="color: #999">客户姓名</div>
          <div style="color: #666" v-if="orderObj.customer">{{ orderObj.customer.name }}</div>
          <div v-else>...</div>
        </div>
        <div class="menuDataOneRight" v-if="orderObj.status != 'R'">
          <div style="color: #999">卡号</div>
          <!-- <div style="color: #666; ">...</div> -->
        </div>
        <div class="menuDataOneRight" v-if="orderObj.status != 'R'">
          <div style="color: #999">市场</div>
          <!-- <div style="color: #666; ">...</div> -->
        </div>
        <div class="menuDataOneRight" v-if="orderObj.status != 'R'">
          <div style="color: #999">来源</div>
          <!-- <div style="color: #666; ">...</div> -->
        </div>
        <div class="menuDataOneRight" v-if="orderObj.status != 'R'">
          <div style="color: #999">单位</div>
          <!-- <div style="color: #666; ">...</div> -->
        </div>

        <div class="menuDataOneRight" @click="openTakeoutdialog">
          <div style="color: #999">外卖单号</div>
          <div style="color: #666">{{ orderObj.takeOutNum ? orderObj.takeOutNum : '...' }}</div>
        </div>

        <div class="menuDataFiveRight" @click="openRemarkDialog">
          <div style="color: #999">备注</div>
          <div style="color: #666">{{ orderObj.remark ? orderObj.remark : '...' }}</div>
        </div>
        <div class="menuDataSixRight" @click="openLogDialog">
          <div style="color: #999">查看日志</div>
          <!-- <div style="color: #666">{{ orderObj.remark }}</div> -->
        </div>
      </div>
      <!-- 全勾吧是弹窗 -->
      <el-dialog title="改数量" :visible.sync="changeFood" width="460px" center>
        <div class="addFoodTTT">{{ funcBtnobj.dishesName }}</div>
        <div class="addFoodMain">
          改为
          <el-input v-model="changeFoodNum" style="width: 200px; margin: 0 15px" :placeholder="funcBtnobj.quantity"></el-input>
          份
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button style="background: #0099ff; color: #fff; width: 120px; height: 60px; border-radius: 38px" @click="changeFood = false">取 消</el-button>
          <el-button style="" type="primary" :loading="buttonLoading" @click="changeNum">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="改价格" :visible.sync="updatemoney" width="460px" center>
        <div class="addFoodTTT">{{ funcBtnobj.dishesName }}</div>
        <div class="addFoodMain">
          <el-input v-model="addFoodNum" style="width: 200px; margin: 0 15px" :placeholder="funcBtnobj.price"></el-input>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button style="background: #0099ff; color: #fff; width: 120px; height: 60px; border-radius: 38px" @click="updatemoney = false">取 消</el-button>
          <el-button style="" type="primary" :loading="buttonLoading" @click="updatemoneyClick">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="改菜名" :visible.sync="updateFood" width="460px" center>
        <div class="addFoodTTT">{{ funcBtnobj.dishesName }}</div>
        <div class="addFoodMain">
          <el-input v-model="addFoodNum" style="width: 200px; margin: 0 15px" :placeholder="funcBtnobj.dishesName"></el-input>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button style="background: #0099ff; color: #fff; width: 120px; height: 60px; border-radius: 38px" @click="updateFood = false">取 消</el-button>
          <el-button style="" type="primary" :loading="buttonLoading" @click="updateFoodClick">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="加菜" :visible.sync="addFood" width="460px" center>
        <div class="addFoodTTT">{{ funcBtnobj.dishesName }}</div>
        <div class="addFoodMain">
          加
          <el-input v-model="addFoodNum" style="width: 200px; margin: 0 15px" placeholder="请输入内容"></el-input>
          份
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button style="background: #0099ff; color: #fff; width: 120px; height: 60px; border-radius: 38px" @click="addFood = false">取 消</el-button>
          <el-button style="" type="primary" :loading="buttonLoading" @click="addfoodCLick">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="退菜" :visible.sync="returnFood" width="970px" center>
        <div class="addFoodTTT">{{ funcBtnobj.dishesName }}</div>
        <div>
          <!-- <div class="changeReason">
            <el-input style="
              width: 100%;
              background: #eee;
              text-indent: 20px;
              margin-top:28px
              font-size: 18px;
            " v-model="changechannelinput" placeholder="输入拼音或者汉字快速查找"></el-input>
          </div> -->
          <div class="returnReason">
            <div class="returnTitle">选择退菜理由（必选）</div>
            <div class="returnItem">
              <div v-for="(v, i) in returnFoodList" :key="i" :class="returnCurrent == i ? 'returnItemCurrent' : ''" @click="checkReturnReason(v, i)">
                {{ v.description }}
              </div>
            </div>
          </div>
          <div class="returnReason">
            <div class="returnTitle">选择退菜理由（必选）</div>
            <div class="returnFoodMain">
              <!-- <div>
                已点：
                <el-input v-model="returnFoodNum" style="width: 200px; margin: 0 15px" placeholder="请输入内容" disabled>
                </el-input>

              </div> -->
              <div>
                退：
                <el-input v-model="returnFoodNum" style="width: 200px; margin: 0 15px" placeholder="请输入内容"></el-input>
              </div>
            </div>
          </div>
        </div>
        <span slot="footer" style="width: 100%; display: flex; justify-content: space-between; align-items: center" class="dialog-footer">
          <div style="color: #fa6400">必须选择理由才可以退菜哦</div>
          <div>
            <el-button style="background: #0099ff; color: #fff; width: 120px; height: 60px; border-radius: 38px" @click="returnFood = false">取 消</el-button>
            <el-button style="" type="primary" :loading="buttonLoading" @click="returnClick">确 定</el-button>
          </div>
        </span>
      </el-dialog>
      <el-dialog title="冲菜" :visible.sync="chongFood" width="970px" center>
        <div class="addFoodTTT">{{ funcBtnobj.dishesName }}</div>
        <div>
          <div class="returnReason">
            <div class="returnTitle">选择理由</div>
            <div class="returnItem">
              <div v-for="(v, i) in ChongFoodList" :key="i" :class="ChongFoodCurrent == i ? 'returnItemCurrent' : ''" @click="checkChongFoodCurrent(v, i)">
                {{ v.description }}
              </div>
            </div>
          </div>
        </div>
        <span slot="footer" style="width: 100%; display: flex; justify-content: flex-end; margin-top: 140px" class="dialog-footer">
          <div>
            <el-button style="background: #0099ff; color: #fff; width: 120px; height: 60px; border-radius: 38px" @click="chongFood = false">取 消</el-button>
            <el-button style="" type="primary" :loading="buttonLoading" @click="chongBTN">确 定</el-button>
          </div>
        </span>
      </el-dialog>
      <el-dialog title="折扣" :visible.sync="saleFood" width="970px" center>
        <div>
          <div class="returnReason">
            <div class="returnTitle">折扣模式</div>
            <div class="returnItem">
              <div v-for="(v, i) in saleFoodList" :key="i" :class="ChongFoodCurrent == i ? 'returnItemCurrent' : ''" @click="checkChongFoodCurrent(i)">
                {{ v }}
              </div>
            </div>
          </div>
          <div class="returnReason">
            <div class="returnTitle">折扣率</div>
            <div class="returnFoodMain">
              <el-input v-model="SaleFoodNum" style="width: 200px; margin: 0 15px 0 0" placeholder="请输入内容"></el-input>
              %
            </div>
          </div>
        </div>
        <span slot="footer" style="width: 100%; display: flex; justify-content: flex-end; margin-top: 80px" class="dialog-footer">
          <div>
            <el-button style="background: #0099ff; color: #fff; width: 120px; height: 60px; border-radius: 38px" @click="saleFood = false">取 消</el-button>
            <el-button style="" type="primary" :loading="buttonLoading">确 定</el-button>
          </div>
        </span>
      </el-dialog>
      <el-dialog title="单菜折扣" :visible.sync="dishesDiscountFlag" width="720px" center>
        <div class="dishesName" style="text-align: center">
          {{ funcBtnobj.dishesName }}
          <span style="color: #e74c3c" v-if="funcBtnobj.totalPrice">{{ funcBtnobj.totalPrice.toFixed(2) }} 元</span>
        </div>
        <div>
          <div class="remarkflex">
            <div class="returnTitle">折扣率 ：</div>
            <div class="returnFoodMain">
              <el-input v-model="funcBtnobj.discountRate" placeholder="请输入折扣率" @input="discountRateChange(1)"></el-input>
            </div>
            <div @click="gift" class="returnGift">赠送</div>
          </div>

          <div class="remarkflex">
            <div class="returnTitle">折后金额：</div>
            <div class="returnFoodMain">
              <el-input v-model="discountMoneys" @input="discountRateChange(2)"></el-input>
            </div>
            <div class="returnNote">元</div>
          </div>
          <div class="remarkflex">
            <div class="returnTitle">打折理由：</div>
            <div class="returnItem">
              <div v-for="(v, i) in ChongFoodList" :key="i" :class="ChongFoodCurrent == i ? 'returnItemCurrent' : ''" @click="checkChongFoodCurrent(v, i)">
                {{ v.name }}
              </div>
            </div>
          </div>

          <div class="remarkflex">
            <div class="returnTitle">备注：</div>
            <div class="returnFoodMain">
              <el-input v-model="funcBtnobj.discountReason" placeholder="请输入备注"></el-input>
            </div>
            <!-- </div> -->
          </div>
        </div>
        <span slot="footer" style="width: 100%; display: flex; justify-content: flex-end; margin-top: 20px" class="dialog-footer">
          <div>
            <el-button style="background: #0099ff; color: #fff; width: 120px; height: 60px; border-radius: 38px" @click="dishesDiscountFlag = false">取 消</el-button>
            <!-- <el-button style="" type="primary" :loading="buttonLoading" @click="givingDishes(0)">赠送</el-button> -->
            <el-button style="" type="primary" :loading="buttonLoading" @click="givingDishes(1)">确 定</el-button>
          </div>
        </span>
      </el-dialog>
      <el-dialog title="请选择桌号换台" :visible.sync="changechannel" width="970px" center>
        <div>
          <div class="changeReason">
            <el-input
              style="
              width: 100%;
              background: #eee;
              text-indent: 20px;
              margin-top:28px
              font-size: 18px;
            "
              v-model="changechannelinput"
              placeholder="输入桌号快速查询"
            ></el-input>
            <div class="returnTitle">选择桌号</div>
            <div class="returnItem">
              <div v-for="(v, i) in saleFoodList" :key="i" :class="ChongFoodCurrent == i ? 'returnItemCurrent' : ''" @click="checkChongFoodCurrent(i)">
                {{ v }}
              </div>
            </div>
          </div>
        </div>
        <span slot="footer" style="width: 100%; display: flex; justify-content: flex-end; margin-top: 80px" class="dialog-footer">
          <div>
            <el-button style="background: #0099ff; color: #fff; width: 120px; height: 60px; border-radius: 38px" @click="changechannel = false">取 消</el-button>
            <el-button style="" type="primary" :loading="buttonLoading">确 定</el-button>
          </div>
        </span>
      </el-dialog>
      <el-dialog title="人数" :visible.sync="peopleDialog" width="460px" center>
        <div class="addFoodMain">
          改为
          <el-input v-model="orderObj.peopleCount" style="width: 200px; margin: 0 15px" placeholder="请输入内容" min="1" max="999" type="number"></el-input>
          人
        </div>
        <span slot="footer" style="width: 100%; display: flex; justify-content: center; margin-top: 10px" class="dialog-footer">
          <el-button style="background: #0099ff; color: #fff; width: 120px; height: 60px; border-radius: 38px" @click="noneorderRecord">取 消</el-button>
          <el-button style="" type="primary" :loading="buttonLoading" @click="updateorderRecord">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="备注" :visible.sync="remarkdialog" width="460px" center>
        <div class="changeReason" style="padding: 0">
          <el-input v-model="orderObj.remark" style="width: 400px; margin: 0 15px" placeholder="请输入备注"></el-input>
        </div>
        <span slot="footer" style="width: 100%; display: flex; justify-content: center; margin-top: 10px" class="dialog-footer">
          <el-button style="background: #0099ff; color: #fff; width: 120px; height: 60px; border-radius: 38px" @click="remarkdialog = false">取 消</el-button>
          <el-button style="" type="primary" :loading="buttonLoading" @click="updateorderRecord">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="外卖单号" :visible.sync="takeoutdialog" width="460px" center>
        <div class="changeReason" style="padding: 0">
          <el-input v-model="orderObj.takeOutNum" style="width: 400px; margin: 0 15px" placeholder="请输入外卖单号"></el-input>
        </div>
        <span slot="footer" style="width: 100%; display: flex; justify-content: center; margin-top: 10px" class="dialog-footer">
          <el-button style="background: #0099ff; color: #fff; width: 120px; height: 60px; border-radius: 38px" @click="takeoutdialog = false">取 消</el-button>
          <el-button style="" type="primary" :loading="buttonLoading" @click="updateorderRecord">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="服务费率" :visible.sync="serviceDialog" width="460px" center>
        <div class="addFoodMain">
          <el-input v-model="changeFoodNum" style="width: 200px; margin: 0 15px" placeholder="请输入内容"></el-input>
          %
        </div>
        <span slot="footer" style="width: 100%; display: flex; justify-content: center; margin-top: 10px" class="dialog-footer">
          <el-button style="background: #0099ff; color: #fff; width: 120px; height: 60px; border-radius: 38px" @click="serviceDialog = false">取 消</el-button>
          <el-button style="" type="primary" :loading="buttonLoading">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="税率" :visible.sync="serviceDialog" width="460px" center>
        <div class="addFoodMain">
          <el-input v-model="changeFoodNum" style="width: 200px; margin: 0 15px" placeholder="请输入内容"></el-input>
          %
        </div>
        <span slot="footer" style="width: 100%; display: flex; justify-content: center; margin-top: 10px" class="dialog-footer">
          <el-button style="background: #0099ff; color: #fff; width: 120px; height: 60px; border-radius: 38px" @click="serviceDialog = false">取 消</el-button>
          <el-button style="" type="primary" :loading="buttonLoading">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="查询会员卡" :visible.sync="vipDialog" width="970px" center>
        <div>
          <div class="changeReason">
            <div style="display: flex; align-items: center; height: 100%; width: 100%; justify-content: space-between">
              <el-input style="width: 80%; background: #eee; text-indent: 20px; font-size: 18px; margin-top: 28px" v-model="vipinput" placeholder="输入名字查找" @change="VIPserch"></el-input>
              <div
                style="width: 120px; height: 60px; text-align: center; line-height: 60px; color: #fff; font-size: 18px; border-radius: 38px; background: #0099ff; margin-top: 28px"
                @click="VIPserch"
              >
                搜索
              </div>
            </div>
            <div class="guestMain">
              <el-table :data="vipList" highlight-current-row @current-change="handleCurrentChange1" height="250" style="width: 100%">
                <el-table-column prop="card_num" label="系统卡号"></el-table-column>
                <el-table-column prop="mac_num" label="卡号"></el-table-column>
                <el-table-column prop="name" label="姓名"></el-table-column>
                <el-table-column prop="gender" :formatter="formatSex" label="性别"></el-table-column>
                <el-table-column prop="mobile" show-overflow-tooltip label="手机">
                  <!-- <template slot-scope="scope">
                  {{scope.row.customer.numCode}}
                </template> -->
                </el-table-column>
                <el-table-column prop="id_card_num" show-overflow-tooltip label="证件号"></el-table-column>
                <el-table-column prop="is_used" :formatter="isUsed" label="状态"></el-table-column>
                <!-- <el-table-column prop="address" label="模式"> </el-table-column> -->
                <el-table-column prop="description" label="卡类型"></el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <span slot="footer" style="width: 100%; display: flex; justify-content: space-between" class="dialog-footer">
          <div class="leftMoney">
            <div class="moneyItem">
              <span>储值余额</span>
              <span>{{ balance.toFixed(2) }}</span>
            </div>
            <div class="moneyItem">
              <span>积分余额</span>
              <span>{{ integral.toFixed(2) }}</span>
            </div>
          </div>
          <div>
            <el-button style="background: #0099ff; color: #fff; width: 120px; height: 60px; border-radius: 38px" @click="vipCancleClick">取 消</el-button>
            <el-button style="" type="primary" :loading="buttonLoading" @click="vipClick">确 定</el-button>
          </div>
        </span>
      </el-dialog>
      <el-dialog title="挂AR账" :visible.sync="ARDialog" width="970px" center>
        <div>
          <div class="changeReason">
            <div style="display: flex; align-items: center; height: 100%; width: 100%; justify-content: space-between">
              <el-input style="width: 100%; background: #eee; text-indent: 20px; font-size: 18px; margin-top: 28px" v-model="ARinput" placeholder="输入名字查找" @change="arSearch"></el-input>
            </div>
            <div class="guestMain">
              <el-table highlight-current-row @current-change="handleCurrentChangeAR" :data="ARtableData" height="250" style="width: 100%">
                <el-table-column prop="code" label="账号"></el-table-column>
                <el-table-column prop="customer_to_name" label="名称"></el-table-column>
                <el-table-column prop="hold_arrow" label="状态"></el-table-column>
                <!-- <el-table-column prop="address" label="记账"> </el-table-column> -->
                <el-table-column prop="cost" label="消费"></el-table-column>
                <el-table-column prop="pay" label="付款"></el-table-column>
                <el-table-column prop="credit_limit" label="信用"></el-table-column>
                <el-table-column prop="total" label="余额"></el-table-column>
                <!-- <el-table-column prop="address" label="备注"> </el-table-column> -->
              </el-table>
            </div>
          </div>
        </div>
        <span slot="footer" style="width: 100%; display: flex; justify-content: flex-end" class="dialog-footer">
          <div>
            <el-button style="background: #0099ff; color: #fff; width: 120px; height: 60px; border-radius: 38px" @click="Arcancleclick">取 消</el-button>
            <el-button style="" type="primary" :loading="buttonLoading" @click="Arclick">确 定</el-button>
          </div>
        </span>
      </el-dialog>
      <el-dialog title="房间帐号查询" :visible.sync="roomSearchDialog" width="970px" center>
        <div>
          <div class="changeReason">
            <div style="display: flex; align-items: center; height: 100%; width: 100%; justify-content: space-between">
              <el-input
                style="width: 80%; background: #eee; text-indent: 20px; font-size: 18px; margin-top: 28px"
                v-model="changechannelinput"
                placeholder="输入名字查找"
                @change="homeSearchClick"
              ></el-input>
              <div
                style="width: 120px; height: 60px; text-align: center; line-height: 60px; color: #fff; font-size: 18px; border-radius: 38px; background: #0099ff; margin-top: 28px"
                @click="homeSearchClick"
              >
                搜索
              </div>
            </div>
            <div class="guestMain">
              <el-table :data="guesttableData" height="250" style="width: 100%" @current-change="handleCurrent" highlight-current-row>
                <el-table-column prop="cirName" label="姓名"></el-table-column>
                <el-table-column prop="roomNum" label="房号"></el-table-column>
                <el-table-column prop="code" show-overflow-tooltip label="账号"></el-table-column>
                <el-table-column prop="gender" label="性别" :formatter="formatSex"></el-table-column>
                <el-table-column prop="status" label="状态"></el-table-column>
                <el-table-column prop="total" label="余额"></el-table-column>
                <el-table-column prop="credit_limit" label="信用"></el-table-column>
                <el-table-column label="可转额度">
                  <template slot-scope="scope">
                    {{ scope.row.credit_limit ? scope.row.credit_limit : 0 + scope.row.total ? scope.row.total : 0 }}
                  </template>
                </el-table-column>
                <el-table-column prop="arriveTime" show-overflow-tooltip label="到店日期"></el-table-column>
                <el-table-column prop="leaveTime" show-overflow-tooltip label="离店日期"></el-table-column>
                <el-table-column label="允许挂账">
                  <template slot-scope="scope">
                    {{ scope.row.hold_arrow ? scope.row.hold_arrow : '未知' }}
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <span slot="footer" style="width: 100%; display: flex; justify-content: flex-end" class="dialog-footer">
          <div>
            <el-button style="background: #0099ff; color: #fff; width: 120px; height: 60px; border-radius: 38px" @click="roomSearchDialog = false">取 消</el-button>
            <el-button style="" type="primary" :loading="buttonLoading" @click="homeclick">确 定</el-button>
          </div>
        </span>
      </el-dialog>
      <el-dialog title="校验密码" :visible.sync="passwordDialog" width="460px" center>
        <div class="psdMain">
          <!--   <el-input
          v-model="changeFoodNum"
          style="width: 200px; margin: 0 15px"
          placeholder="请输入内容"
           v-model.number="numberValidateForm.age" autocomplete="off"
        ></el-input> -->

          <el-form :model="numberValidateForm" ref="numberValidateForm" label-width="100px" class="demo-ruleForm">
            <el-form-item
              prop="age"
              :rules="[
                { required: true, message: '密码不能为空' },
                { type: 'number', message: '密码必须为数字值' },
              ]"
            >
              <!-- <el-input type="age"  style="width: 200px; margin: 0 15px" v-model.number="numberValidateForm.age" autocomplete="off"></el-input> -->
              <el-input type="password" v-model="changeFoodNum" placeholder="请输入内容" v-model.number="numberValidateForm.age" autocomplete="off"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button style="background: #0099ff; color: #fff; width: 120px; height: 60px; border-radius: 38px" @click="changeFood = false">取 消</el-button>
          <el-button style="" type="primary" :loading="buttonLoading">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="查询日志" :visible.sync="logDialog" width="1000px" center>
        <div>
          <div class="changeReason">
            <div class="guestMain">
              <el-table :data="discountList" height="250" style="width: 100%">
                <el-table-column prop="productValue" label="订单号"></el-table-column>
                <el-table-column prop="product" label="修改"></el-table-column>
                <el-table-column prop="updateProduct" label="修改项"></el-table-column>
                <el-table-column prop="oldValue" label="旧值/key"></el-table-column>
                <el-table-column prop="newValue" label="新值/value"></el-table-column>
                <el-table-column prop="createDate" label="修改时间"></el-table-column>
                <el-table-column prop="createName" label="操作员"></el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <span slot="footer" style="width: 100%; display: flex; justify-content: flex-end" class="dialog-footer">
          <div>
            <el-button style="background: #0099ff; color: #fff; width: 120px; height: 60px; border-radius: 38px" @click="logDialog = false">取 消</el-button>
            <el-button style="" type="primary" :loading="buttonLoading" @click="logDialog = false">确 定</el-button>
          </div>
        </span>
      </el-dialog>
      <el-dialog title="查询协议档案" :visible.sync="guestDialogs" width="970px" center>
        <div>
          <div class="changeReason">
            <el-input style="width: 100%; background: #eee; text-indent: 20px; font-size: 18px; margin-top: 28px" v-model="changechannelinput" placeholder="输入名字查找协议档案"></el-input>
            <div class="guestMain">
              <el-table :data="guesttableData" height="250" style="width: 100%">
                <el-table-column prop="date" label="档案号"></el-table-column>
                <el-table-column prop="name" label="姓名"></el-table-column>
                <el-table-column prop="address" label="入住次数"></el-table-column>
                <el-table-column prop="address" label="类别"></el-table-column>
                <el-table-column prop="address" label="证件号"></el-table-column>
                <el-table-column prop="address" label="国籍"></el-table-column>
                <el-table-column prop="address" label="城市"></el-table-column>
                <el-table-column prop="address" label="手机"></el-table-column>
                <el-table-column prop="address" label="等级"></el-table-column>
                <el-table-column prop="address" label="餐饮模式"></el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <span slot="footer" style="width: 100%; display: flex; justify-content: flex-end" class="dialog-footer">
          <div>
            <el-button style="background: #0099ff; color: #fff; width: 120px; height: 60px; border-radius: 38px" @click="SalerDialog = false">取 消</el-button>
            <el-button style="" type="primary" :loading="buttonLoading">确 定</el-button>
          </div>
        </span>
      </el-dialog>
      <el-dialog title="查询客人档案" :visible.sync="guestDialog" width="970px" center>
        <div>
          <div class="changeReason">
            <el-input
              style="width: 100%; background: #eee; text-indent: 20px; font-size: 18px; margin-top: 28px"
              v-model="changechannelinput"
              placeholder="输入名字查找客人档案"
              @change="surfendchannelinput"
            ></el-input>
            <div class="guestMain">
              <el-table :data="guesttableData" height="250" style="width: 100%" highlight-current-row @current-change="handleCurrentChange">
                <el-table-column prop="numCode" show-overflow-tooltip label="档案号"></el-table-column>
                <el-table-column prop="name" label="姓名"></el-table-column>
                <el-table-column prop="custmerType" show-overflow-tooltip label="类别"></el-table-column>
                <el-table-column prop="idCardNum" show-overflow-tooltip label="证件号"></el-table-column>
                <el-table-column prop="nationality" label="国籍"></el-table-column>
                <el-table-column prop="address" label="城市"></el-table-column>
                <el-table-column prop="mobile" show-overflow-tooltip label="手机"></el-table-column>
                <el-table-column prop="levelName" show-overflow-tooltip label="等级"></el-table-column>
                <el-table-column prop="resType" show-overflow-tooltip label="餐饮模式"></el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <span slot="footer" style="width: 100%; display: flex; justify-content: flex-end" class="dialog-footer">
          <div>
            <el-button style="background: #0099ff; color: #fff; width: 120px; height: 60px; border-radius: 38px" @click="guestDialog = false">取 消</el-button>
            <el-button style="" type="primary" :loading="buttonLoading" @click="updateorderRecord">确 定</el-button>
          </div>
        </span>
      </el-dialog>
      <el-dialog title="联单" :visible.sync="SingleCopy" width="970px">
        <div>
          <div class="LDReason">
            <div class="guestMain">
              <el-table :data="SingleCopyData" height="250" ref="SingleCopyData" style="width: 100%" @selection-change="handleSelectionChange">
                <el-table-column type="selection"></el-table-column>
                <el-table-column prop="order_num" label="单号"></el-table-column>
                <el-table-column prop="tableNum" label="桌号"></el-table-column>
                <el-table-column prop="people_count" label="人数"></el-table-column>
                <el-table-column prop="status" label="状态"></el-table-column>
                <el-table-column label="金额" align="right">
                  <template slot-scope="scope">
                    <span>{{ scope.row.all_price.toFixed(2) }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="link_num" label="联单号"></el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <div class="ldFooter">
            <el-radio-group v-model="timeradio1" @change="fetchLink">
              <el-radio label="true">显示未联</el-radio>
              <el-radio label="false">不显示未联</el-radio>
            </el-radio-group>
            <div>
              <el-button style="background: #0099ff; color: #fff; width: 120px; height: 60px; border-radius: 38px" @click="SingleCopy = false">取 消</el-button>
              <el-button style="" type="primary" :loading="buttonLoading" @click="SingleCopySure">确 定</el-button>
            </div>
          </div>
        </span>
      </el-dialog>
      <el-dialog :title="dialogtitle" :visible.sync="dialogtitleFlag" width="520px" center>
        <div class="addFoodTTT"></div>
        <div class="takeOutFoodMain">
          <el-input v-model="changeFoodNum" style="width: 400px; margin: 0 15px" placeholder="请输入内容"></el-input>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button style="background: #0099ff; color: #fff; width: 120px; height: 60px; border-radius: 38px" @click="dialogtitleFlag = false">取 消</el-button>
          <el-button style="" type="primary" :loading="buttonLoading" @click="primarydialog">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="请选择市场进行更换" :visible.sync="SalerDialog" width="970px" center>
        <div>
          <div class="changeReason">
            <div class="returnTitle">选择市场</div>
            <div class="returnItem">
              <div v-for="(v, i) in saleFoodList" :key="i" :class="ChongFoodCurrent == i ? 'returnItemCurrent' : ''" @click="checkChongFoodCurrent(i)">
                {{ v }}
              </div>
            </div>
          </div>
        </div>
        <span slot="footer" style="width: 100%; display: flex; justify-content: flex-end; margin-top: 80px" class="dialog-footer">
          <div>
            <el-button style="background: #0099ff; color: #fff; width: 120px; height: 60px; border-radius: 38px" @click="SalerDialog = false">取 消</el-button>
            <el-button style="" type="primary" :loading="buttonLoading">确 定</el-button>
          </div>
        </span>
      </el-dialog>
      <el-dialog title="请选来源进行更换" :visible.sync="SalerDialog" width="970px" center>
        <div>
          <div class="changeReason">
            <div class="returnTitle">选择来源</div>
            <div class="returnItem">
              <div v-for="(v, i) in saleFoodList" :key="i" :class="ChongFoodCurrent == i ? 'returnItemCurrent' : ''" @click="checkChongFoodCurrent(i)">
                {{ v }}
              </div>
            </div>
          </div>
        </div>
        <span slot="footer" style="width: 100%; display: flex; justify-content: flex-end; margin-top: 80px" class="dialog-footer">
          <div>
            <el-button style="background: #0099ff; color: #fff; width: 120px; height: 60px; border-radius: 38px" @click="SalerDialog = false">取 消</el-button>
            <el-button style="" type="primary" :loading="buttonLoading">确 定</el-button>
          </div>
        </span>
      </el-dialog>
      <el-dialog title="销单" :visible.sync="SalesOrder" width="970px" center>
        <div>
          <div class="changeReason">
            <div class="returnTitle">选择销单理由</div>
            <div class="returnItem">
              <div v-for="(v, i) in ChongFoodList" :key="i" :class="ChongFoodCurrent == i ? 'returnItemCurrent' : ''" @click="checkChongFoodCurrent(v, i)">
                {{ v.description }}
              </div>
            </div>
          </div>
        </div>
        <span slot="footer" style="width: 100%; display: flex; justify-content: flex-end; margin-top: 80px" class="dialog-footer">
          <div>
            <el-button style="background: #0099ff; color: #fff; width: 120px; height: 60px; border-radius: 38px" @click="SalesOrder = false">取 消</el-button>
            <el-button style="" type="primary" :loading="buttonLoading" @click="SalesOrderClick">确 定</el-button>
          </div>
        </span>
      </el-dialog>
      <el-dialog title="挂单" :visible.sync="dieOrder" width="460px" center>
        <div class="addFoodMain">是否确认将此菜单挂起？</div>
        <span slot="footer" style="width: 100%; display: flex; justify-content: center" class="dialog-footer">
          <div>
            <el-button style="background: #0099ff; color: #fff; width: 120px; height: 60px; border-radius: 38px" @click="dieOrder = false">取 消</el-button>
            <el-button style="" type="primary" :loading="buttonLoading" @click="dieOrderClick">确 定</el-button>
          </div>
        </span>
      </el-dialog>
      <el-dialog title="追回" :visible.sync="recoverFlag" width="460px" center>
        <div class="addFoodMain">是否将此挂单追回</div>
        <span slot="footer" style="width: 100%; display: flex; justify-content: center" class="dialog-footer">
          <div>
            <el-button style="background: #0099ff; color: #fff; width: 120px; height: 60px; border-radius: 38px" @click="recoverFlag = false">取 消</el-button>
            <el-button style="" type="primary" :loading="buttonLoading" @click="recoverOnclick">确 定</el-button>
          </div>
        </span>
      </el-dialog>
      <el-dialog title="提醒" :visible.sync="cxrefund" width="460px" center>
        <div class="addFoodMain">是否确撤销结账？</div>
        <span slot="footer" style="width: 100%; display: flex; justify-content: center" class="dialog-footer">
          <div>
            <el-button style="background: #0099ff; color: #fff; width: 120px; height: 60px; border-radius: 38px" @click="cxrefund = false">取 消</el-button>
            <el-button style="" type="primary" :loading="buttonLoading" @click="cxrefundClick">确 定</el-button>
          </div>
        </span>
      </el-dialog>
      <el-dialog title="估清" :visible.sync="SalerDialog" width="460px" center>
        <div class="addFoodMain">
          估清
          <el-input v-model="changeFoodNum" style="width: 200px; margin: 0 15px" placeholder="请输入内容"></el-input>
          份
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button style="background: #0099ff; color: #fff; width: 120px; height: 60px; border-radius: 38px" @click="changeFood = false">取 消</el-button>
          <el-button style="" type="primary" :loading="buttonLoading">确 定</el-button>
        </span>
      </el-dialog>
      <div class="singleDialog" v-if="singleDialog">
        <el-dialog title="分单" :visible.sync="singleDialog" center width="90%">
          <div class="singleTitle">
            <div class="minus" v-if="singleNum > 2" @click="singleNumberBtn(0)">减少</div>
            <div class="add" v-if="singleNum < 4" @click="singleNumberBtn(1)">增加</div>
          </div>
          <div class="singleMain">
            <div class="singleBox" @click.stop="removerow(1)">
              <el-table
                ref="singleList1"
                :data="singleList1"
                tooltip-effect="dark"
                style="width: 100%"
                height="450"
                @selection-change="singleSelectionChange($event, 1)"
                @row-click="(row, column, e) => handleRowClick(row, column, e, 1)"
                @select-all="selections => handleRowAllClick(selections, 1)"
                :row-style="rowStyle"
                :row-class-name="singleClassNameList1"
              >
                <el-table-column type="selection" width="30" :selectable="selectable"></el-table-column>
                <el-table-column label="菜名" show-overflow-tooltip>
                  <template slot-scope="scope">{{ scope.row.dishesName }}</template>
                </el-table-column>
                <el-table-column prop="quantity" label="数量" width="80">
                  <template slot-scope="scope">{{ (scope.row.quantity * 1).toFixed(2) }}{{ scope.row.unitName }}</template>
                </el-table-column>
                <el-table-column prop="price" label="单价" width="60"></el-table-column>
                <el-table-column prop="totalPrice" label="原价" width="80">
                  <template slot-scope="scope">{{ (scope.row.totalPrice * 1).toFixed(2) }}</template>
                </el-table-column>
                <!-- <el-table-column prop="allPrice" label="折后" width="70">
              </el-table-column> -->
              </el-table>
              <div class="singleBoxtotal" v-if="singleList1.length">
                <div v-for="(td, index) in singleList1Total" :key="index">
                  {{ td }}
                </div>
              </div>
            </div>
            <div class="singleBox" @click="removerow(2)">
              <el-table
                ref="singleList2"
                :data="singleList2"
                tooltip-effect="dark"
                style="width: 100%"
                height="450"
                @selection-change="singleSelectionChange($event, 2)"
                @row-click="(row, column, e) => handleRowClick(row, column, e, 2)"
                @select-all="selections => handleRowAllClick(selections, 2)"
                :row-style="rowStyle"
                :row-class-name="singleClassNameList2"
              >
                <el-table-column type="selection" width="30" :selectable="selectable"></el-table-column>
                <el-table-column label="菜名" show-overflow-tooltip>
                  <template slot-scope="scope">{{ scope.row.dishesName }}</template>
                </el-table-column>
                <el-table-column prop="quantity" label="数量" width="80">
                  <template slot-scope="scope">{{ (scope.row.quantity * 1).toFixed(2) }}{{ scope.row.unitName }}</template>
                </el-table-column>
                <el-table-column prop="price" label="单价" width="60"></el-table-column>
                <el-table-column prop="totalPrice" label="原价" width="80">
                  <template slot-scope="scope">{{ (scope.row.totalPrice * 1).toFixed(2) }}</template>
                </el-table-column>
                <!-- <el-table-column prop="allPrice" label="折后" width="70">
              </el-table-column> -->
              </el-table>
              <div class="singleBoxtotal" v-if="singleList2.length">
                <div v-for="(td, index) in singleList2Total" :key="index">
                  {{ td }}
                </div>
              </div>
            </div>
            <div class="singleBox" @click="removerow(3)" v-if="singleNum >= 3">
              <el-table
                ref="singleList3"
                :data="singleList3"
                tooltip-effect="dark"
                style="width: 100%"
                height="450"
                @selection-change="singleSelectionChange($event, 3)"
                @row-click="(row, column, e) => handleRowClick(row, column, e, 3)"
                @select-all="selections => handleRowAllClick(selections, 3)"
                :row-style="rowStyle"
                :row-class-name="singleClassNameList3"
              >
                <el-table-column type="selection" width="30" :selectable="selectable"></el-table-column>
                <el-table-column label="菜名" show-overflow-tooltip>
                  <template slot-scope="scope">{{ scope.row.dishesName }}</template>
                </el-table-column>
                <el-table-column prop="quantity" label="数量" width="80">
                  <template slot-scope="scope">{{ (scope.row.quantity * 1).toFixed(2) }}{{ scope.row.unitName }}</template>
                </el-table-column>
                <el-table-column prop="price" label="单价" width="60"></el-table-column>
                <el-table-column prop="totalPrice" label="原价" width="80">
                  <template slot-scope="scope">{{ (scope.row.totalPrice * 1).toFixed(2) }}</template>
                </el-table-column>
                <!-- <el-table-column prop="allPrice" label="折后" width="70">
              </el-table-column> -->
              </el-table>
              <div class="singleBoxtotal" v-if="singleList3.length">
                <div v-for="(td, index) in singleList3Total" :key="index">
                  {{ td }}
                </div>
              </div>
            </div>
            <div class="singleBox" @click="removerow(4)" v-if="singleNum == 4">
              <el-table
                ref="singleList4"
                :data="singleList4"
                tooltip-effect="dark"
                style="width: 100%"
                height="450"
                @selection-change="singleSelectionChange($event, 4)"
                @row-click="(row, column, e) => handleRowClick(row, column, e, 4)"
                @select-all="selections => handleRowAllClick(selections, 4)"
                :row-style="rowStyle"
                :row-class-name="singleClassNameList4"
              >
                <el-table-column type="selection" width="30" :selectable="selectable"></el-table-column>
                <el-table-column label="菜名" show-overflow-tooltip>
                  <template slot-scope="scope">{{ scope.row.dishesName }}</template>
                </el-table-column>
                <el-table-column prop="quantity" label="数量" width="80">
                  <template slot-scope="scope">{{ (scope.row.quantity * 1).toFixed(2) }}{{ scope.row.unitName }}</template>
                </el-table-column>
                <el-table-column prop="price" label="单价" width="60"></el-table-column>
                <el-table-column prop="totalPrice" label="原价" width="80">
                  <template slot-scope="scope">{{ (scope.row.totalPrice * 1).toFixed(2) }}</template>
                </el-table-column>
                <!-- <el-table-column prop="allPrice" label="折后" width="70">
              </el-table-column> -->
              </el-table>
              <div class="singleBoxtotal" v-if="singleList4.length">
                <div v-for="(td, index) in singleList4Total" :key="index">
                  {{ td }}
                </div>
              </div>
            </div>
          </div>

          <span slot="footer" class="dialog-footer">
            <el-button style="background: #0099ff; color: #fff; width: 120px; height: 60px; border-radius: 38px" @click="singleDialog = false">取 消</el-button>
            <el-button style="background: #0099ff; color: #fff; width: 120px; height: 60px; border-radius: 38px" @click="averageDialog">平 分</el-button>
            <el-button style="background: #0099ff; color: #fff; width: 120px; height: 60px; border-radius: 38px" @click="resetList">重 置</el-button>
            <el-button style="" type="primary" @click="splitMenu" :loading="buttonLoading">确 定</el-button>
          </span>
        </el-dialog>
      </div>
      <el-dialog title="选择平分菜单" :visible.sync="averagelistDialog" width="700px" center>
        <div class="discountflag">
          <div v-for="(td, index) in averagelists" :key="index" @click="singleSelectItem(td, index)" v-if="index < singleNum">
            <div class="discountflagitem" :class="td.check ? 'returnItemCurrent' : ''">
              {{ index + 1 }}
            </div>
          </div>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button style="background: #0099ff; color: #fff; width: 120px; height: 60px; border-radius: 38px" @click="averagelistDialog = false">取 消</el-button>
          <el-button style="margin-left: 70px" type="primary" @click="averagelist">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="选择分单数量" :visible.sync="singleMoreListDialog" width="500px" center>
        <div class="singleMore">
          <div v-for="(td, index) in singleMoreList" :key="index" class="">
            <div class="label">
              <div class="name">{{ td.dishesName }}:</div>
              <div>
                <el-input v-model="td.Numbers" :placeholder="td.quantity"></el-input>
                <span>{{ td.unitName }}</span>
              </div>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button style="background: #0099ff; color: #fff; width: 120px; height: 60px; border-radius: 38px" @click="singleMoreListDialog = false">取 消</el-button>
          <el-button style="margin-left: 70px" type="primary" @click="singleMoreSubmit">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="计时" :visible.sync="readyTime" width="530px" center>
        <div class="addFoodMain">
          <span style="margin-right: 20px">计时用时</span>
          <el-input v-model="changeFoodNum" style="width: 200px; margin: 0 15px" placeholder="请输入内容"></el-input>
          分钟
        </div>
        <div class="timeStop">
          <el-radio-group v-model="timeradio">
            <el-radio label="到期停止">到期停止</el-radio>
            <el-radio label="到期继续">到期继续</el-radio>
          </el-radio-group>
        </div>
        <div class="startTimeAndEndTime">
          <div class="timeItem">
            <span>开始时间</span>
            <span>2021-05-20 16:33:12</span>
          </div>
          <div class="timeItem">
            <span>结束时间</span>
            <span>2021-05-20 16:33:12</span>
          </div>
          <div class="timeItem">
            <span>已用时</span>
            <div class="timeED">
              <span style="">0</span>
              分钟
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-checkbox v-model="timechecked">到期提醒</el-checkbox>

          <el-button style="margin-left: 70px" type="primary">确 定</el-button>
        </span>
      </el-dialog>
      <div v-if="payDialog" class="jiezhang">
        <el-dialog title="结账付款" :visible.sync="payDialog" width="960px" center :before-close="beforeClose">
          <div class="addFoodTTT">
            单号：{{ payOrderNum }} &nbsp; &nbsp;&nbsp;
            <span>桌号：{{ payTableNum }}</span>
            &nbsp;&nbsp;&nbsp; 应付金额：{{ this.alltotalPrice }}
          </div>

          <el-table :data="paytableData" :key="itemKey" height="180" style="width: 100%">
            <el-table-column prop="productCode" label="付款码"></el-table-column>
            <el-table-column prop="productName" label="描述"></el-table-column>
            <el-table-column prop="accounname" show-overflow-tooltip label="账号"></el-table-column>
            <el-table-column prop="transactionId" show-overflow-tooltip label="流水单号"></el-table-column>
            <el-table-column prop="totalPrice" label="金额"></el-table-column>
            <el-table-column prop="remark" label="备注"></el-table-column>
            <el-table-column fixed="right" label="操作" width="120">
              <template slot-scope="scope">
                <!-- v-show='scope.row.transactionId' -->
                <el-button v-if="!scope.row.transactionId && !scope.row.updateDate" @click.native.prevent="deleteRow(scope.$index, paytableData, scope.row)" type="text" size="small">移除</el-button>
                <span v-else>支付成功</span>
              </template>
            </el-table-column>
          </el-table>
          <div class="paytableunder">
            <div class="underLeft">
              <el-input v-model="bzinput1" style="background: #eee; width: 413px; height: 65px; text-indent: 10px; border-radius: 6px; margin: 16px 0 10px 0" placeholder="请输入备注"></el-input>

              <el-input
                v-model="lsinput2"
                style="background: #eee; width: 413px; height: 65px; text-indent: 10px; border-radius: 6px"
                placeholder="请输入流水单号"
                autofocus="autofocus"
                ref="gain"
              ></el-input>
            </div>
            <div class="underMiddle">
              <div>金额</div>
              <div>
                <el-input style="font-size: 24px" v-model="jzmoney"></el-input>
              </div>
            </div>
            <div class="Collection" @click="takeMoney">收款</div>
          </div>

          <div class="payMethods">
            <div class="methodItem" v-for="(v, i) in methodItem" :key="i" @click="methodClick(v, i)">
              <!-- <img :src="imgBaseurl + v.icon_path" width="40px" height="40px" style="margin-bottom: 5px" alt="" /> -->

              <el-image :src="imgBaseurl + v.icon_path" lazy fit="cover" style="height: 40px%; width: 40px">
                <div slot="error" class="image-slot">
                  <img src="../../../assets/imgs/zhuanfangzhang.png" width="40px" height="40px" alt="" />
                </div>
              </el-image>
              <span>{{ v.name }}</span>
            </div>
          </div>
        </el-dialog>
      </div>
      <el-dialog title="账单" :visible.sync="printFlag" width="550px" center @close="closeprintFlag">
        <div class="printSelect" v-if="checkPrinter == 1">
          <div class="printNameTxt">当前打印机：</div>
          <el-select v-model="printName" placeholder="请选择" class="PDateName" @change="changePDate">
            <el-option v-for="item in PDate" :key="item.value" :label="item.name" :value="item.name"></el-option>
          </el-select>
        </div>
        <div style="width: 100%; display: flex; justify-content: center">
          <bill :orderObj="printobj" ref="billb" />
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button style="background: #0099ff; color: #fff; width: 120px; height: 60px; border-radius: 38px" @click="printFlag = false">返 回</el-button>
          <el-button style="" type="primary" :loading="buttonLoading" @click="printtable">打 印</el-button>
        </span>
      </el-dialog>

      <el-dialog title="返现" :visible.sync="CashBack" width="970px" center>
        <div>
          <div class="returnReason">
            <div class="returnTitle">返现金额</div>
            <div class="returnFoodMain">
              <el-input v-model="addFoodNum" style="width: 200px; margin-right: 15px" placeholder="请输入内容"></el-input>
              份
            </div>
          </div>
          <div class="returnReason">
            <div class="returnTitle">备注</div>
            <div>
              <textarea name="" id="" style="width: 100%; height: 120px; font-size: 20px" placeholder="请输入备注"></textarea>
            </div>
          </div>
        </div>
        <span slot="footer" style="width: 100%; display: flex; justify-content: flex-end; align-items: center" class="dialog-footer">
          <div>
            <el-button style="background: #0099ff; color: #fff; width: 120px; height: 60px; border-radius: 38px" @click="CashBack = false">取 消</el-button>
            <el-button style="" type="primary" :loading="buttonLoading">确 定</el-button>
          </div>
        </span>
      </el-dialog>
      <el-dialog title="打折模式" :visible.sync="discountflag" width="970px" center>
        <div class="discountflag">
          <div class="discountflagitem" v-for="(v, i) in discountList" :key="i" :class="v.check ? 'returnItemCurrent' : ''" @click="selectdiscountItem(v, i)">
            {{ v.name }}
          </div>
        </div>
        <div class="discountText">
          <div>
            <div class="discountTxt">
              <div class="boldText">原单金额：</div>
              <div class="boldText">{{ (orderObj.totalPrice * 1).toFixed(2) }}</div>
            </div>
            <div class="discountTxt">
              <div class="boldText">打折比例：</div>
              <div>
                <el-input v-model="discountObj.disPro" @input="changeDisPro"></el-input>
              </div>
            </div>
            <div class="discountTxt">
              <div class="boldText">折后金额：</div>
              <div>
                <el-input v-model="discountObj.money" disabled></el-input>
              </div>
            </div>
          </div>
          <div class="discountRemark">
            <div class="boldText">下方输入备注:</div>
            <div class="discounttextarea">
              <el-input type="textarea" :rows="7" v-model="discountObj.remark"></el-input>
            </div>
          </div>
        </div>
        <span slot="footer" style="width: 100%; display: flex; justify-content: flex-end; align-items: center" class="dialog-footer">
          <div>
            <el-button style="background: #0099ff; color: #fff; width: 120px; height: 60px; border-radius: 38px" @click="discountflag = false">取 消</el-button>
            <el-button style="" type="primary" :loading="buttonLoading" @click="discountprimary">确 定</el-button>
          </div>
        </span>
      </el-dialog>
      <el-dialog title="修改类别" :visible.sync="menuTypeNameflag" width="970px" center>
        <div class="discountflag">
          <div class="discountflagitem" v-for="(v, i) in discountList" :key="i" :class="v.check ? 'returnItemCurrent' : ''" @click="selectmenuTypeName(v, i)">
            {{ v.description }}
          </div>
        </div>
        <span slot="footer" style="width: 100%; display: flex; justify-content: flex-end; align-items: center" class="dialog-footer">
          <div>
            <el-button style="background: #0099ff; color: #fff; width: 120px; height: 60px; border-radius: 38px" @click="menuTypeNameflag = false">取 消</el-button>
            <el-button style="" type="primary" :loading="buttonLoading" @click="updateorderRecord">确 定</el-button>
          </div>
        </span>
      </el-dialog>
      <el-dialog title="修改服务员" :visible.sync="openwaiterflag" width="970px" center>
        <div class="dialoginput">
          <el-input v-model="openwaitername" placeholder="输入名字或拼音首字母查找服务员" @change="openwaiter">
            <i slot="suffix" class="el-icon-search" style="font-size: 20px; line-height: 40px" @click="openwaiter"></i>
          </el-input>
        </div>
        <div class="dialogname">选择服务员</div>
        <div class="discountflag">
          <div class="discountflagitem" v-for="(v, i) in discountList" :key="i" :class="v.check ? 'returnItemCurrent' : ''" @click="selectdiscountwaiterItem(v, i)">
            {{ v.description }}
          </div>
        </div>
        <span slot="footer" style="width: 100%; display: flex; justify-content: flex-end; align-items: center" class="dialog-footer">
          <div>
            <el-button style="background: #0099ff; color: #fff; width: 120px; height: 60px; border-radius: 38px" @click="openwaiterflag = false">取 消</el-button>
            <el-button style="" type="primary" :loading="buttonLoading" @click="updateorderRecord">确 定</el-button>
          </div>
        </span>
      </el-dialog>
      <el-dialog title="请选择桌号批量换菜" :visible.sync="openTableNumflag" width="970px" center>
        <div class="CTClassification">
          <div class="ctItem" v-for="(v, i) in cantList" :key="i" :class="current == i ? 'currentCT' : ''" @click="currentCheck(v, i)">
            {{ v.description }}
          </div>
        </div>
        <div class="dialoginput">
          <el-input v-model="openwaitername" placeholder="输入桌号快速查询" @change="openmealTable">
            <i slot="suffix" class="el-icon-search" style="font-size: 18px; line-height: 40px" @click="openmealTable"></i>
          </el-input>
        </div>
        <div class="dialogname">选择桌号</div>
        <div class="discountflag">
          <div class="discountflagitem" v-for="(v, i) in TableList" :key="i" :class="v.check ? 'returnItemCurrent' : ''" @click="selectopenTableList(v, i)">
            {{ v.code }}

            <span>
              (
              {{
                v.statusCode == 'D'
                  ? '脏台'
                  : v.statusCode == 'G'
                  ? '送单'
                  : v.statusCode == 'V'
                  ? '空闲'
                  : v.statusCode == 'R'
                  ? '预订'
                  : v.statusCode == 'U'
                  ? '开台'
                  : v.statusCode == 'OO'
                  ? '维修'
                  : v.statusCode == 'L'
                  ? '点菜'
                  : '空闲'
              }})
            </span>
          </div>
        </div>
        <span slot="footer" style="width: 100%; display: flex; justify-content: flex-end; align-items: center" class="dialog-footer">
          <div>
            <el-button style="background: #0099ff; color: #fff; width: 120px; height: 60px; border-radius: 38px" @click="openTableNumflag = false">取 消</el-button>
            <el-button style="" type="primary" :loading="buttonLoading" @click="transferMenus">确 定</el-button>
          </div>
        </span>
      </el-dialog>
      <el-dialog title="请选择桌号换台" :visible.sync="openmealTableNumflag" width="970px" center>
        <div class="dialoginput">
          <el-input v-model="openwaitername" placeholder="输入桌号快速查询" @change="openmealTable">
            <i slot="suffix" class="el-icon-search" style="font-size: 20px; line-height: 40px" @click="openmealTable"></i>
          </el-input>
        </div>
        <div class="dialogname">选择桌号</div>
        <div class="discountflag">
          <div class="discountflagitem" v-for="(v, i) in discountList" :key="i" :class="v.check ? 'returnItemCurrent' : ''" @click="selectopenwaitername(v, i)">
            {{ v.code }}
          </div>
        </div>
        <span slot="footer" style="width: 100%; display: flex; justify-content: flex-end; align-items: center" class="dialog-footer">
          <div>
            <el-button style="background: #0099ff; color: #fff; width: 120px; height: 60px; border-radius: 38px" @click="openmealTableNumflag = false">取 消</el-button>
            <el-button style="" type="primary" :loading="buttonLoading" @click="updatemealTableNum">确 定</el-button>
          </div>
        </span>
      </el-dialog>
      <el-dialog title="修改销售员" :visible.sync="opensalesPersonflag" width="970px" center>
        <div class="dialoginput">
          <el-input v-model="openwaitername" placeholder="输入名字或拼音首字母查找销售员" @change="opensalesPersons">
            <i slot="suffix" class="el-icon-search" style="font-size: 20px; line-height: 40px" @click="opensalesPerson"></i>
          </el-input>
        </div>
        <div class="dialogname">选择销售员</div>
        <div class="discountflag">
          <div class="discountflagitem" v-for="(v, i) in discountList" :key="i" :class="v.check ? 'returnItemCurrent' : ''" @click="selectdiscountsalesPersonItem(v, i)">
            {{ v.description }}
          </div>
        </div>
        <span slot="footer" style="width: 100%; display: flex; justify-content: flex-end; align-items: center" class="dialog-footer">
          <div>
            <el-button style="background: #0099ff; color: #fff; width: 120px; height: 60px; border-radius: 38px" @click="opensalesPersonflag = false">取 消</el-button>
            <el-button style="" type="primary" :loading="buttonLoading" @click="updateorderRecord">确 定</el-button>
          </div>
        </span>
      </el-dialog>

      <!-- 折扣或者赠送 -->
      <el-dialog :title="discountAndGift" :visible.sync="discount" width="840px" center>
        <div style="display: flex; justify-content: space-between; width: 100%">
          <div class="discountReason">
            <div class="returnFoodMain">
              打折模式
              <el-select v-model="value" placeholder="请选择" style="width: 303px; margin: 0px 15px 0 10px">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </div>
            <div class="returnFoodMain">
              折扣比例
              <el-input v-model="addFoodNum" style="width: 303px; margin: 0px 15px 0 10px" placeholder="请输入内容"></el-input>
            </div>
            <!-- <div class="returnFoodMain">
            授权工号
            <el-select v-model="value" placeholder="请选择" style="width: 303px; margin:0px 15px 0 10px">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div> -->
            <div class="returnFoodMain">
              授权手机
              <el-select v-model="value" placeholder="请选择" style="width: 227px; margin: 0px 10px 0 10px">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
              <div
                class=""
                style="cursor: pointer; width: 66px; height: 66px; color: #fff; background: #0099ff; text-align: center; line-height: 33px; border-radius: 6px; font-size: 20px; padding: 0 5px"
              >
                发送验证
              </div>
            </div>
            <div class="returnFoodMain">
              授权密码
              <el-input v-model="addFoodNum" type="password" style="width: 303px; margin: 0px 15px 0 10px" placeholder="请输入内容"></el-input>
            </div>
          </div>
          <div class="soft_keyboard">
            <div class="keyItem" v-for="(v, i) in keyboardList" :key="i" @click="keyBoardClick(v)">
              {{ v }}
            </div>
          </div>
        </div>
        <span slot="footer" style="width: 100%; display: flex; justify-content: flex-end; align-items: center" class="dialog-footer">
          <div>
            <el-button style="background: #0099ff; color: #fff; width: 120px; height: 60px; border-radius: 38px" @click="discount = false">取 消</el-button>
            <el-button style="" type="primary" :loading="buttonLoading">确 定</el-button>
          </div>
        </span>
      </el-dialog>

      <el-drawer title="消息中心" :visible.sync="messageDrawer" :direction="direction" :before-close="handleClose" :modal="false">
        <div class="messageMain">
          <div class="messageItem">
            <div class="titleMessage">
              <span>计时菜提醒</span>
              <span>2021-05-20 11:22:13</span>
            </div>
            <div class="messageContent">西餐006桌的豌豆西蓝花牛肉沙拉计时时间到，已停止计时。</div>
          </div>
        </div>
      </el-drawer>

      <print v-show="false" :orderObj="orderObj" ref="print"></print>
    </div>
    <!-- </div> -->
  </div>
</template>

<script>
import bill from './bill.vue';
import print from '@/views/components/print.vue';
import getLodop from '@/utils/Lodopfuncs';
import DateUtils from '@/utils/DateUtils';

export default {
  props: {
    dcStatus: {
      type: String,
    },
    showReCalc: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      logDialog: false,
      cxRefundFlag: true,
      integral: 0,
      balance: 0,
      printobj: '',
      buttonLoading: false,
      description: '',
      //打印机弹窗开关
      printFlag: false,
      shopobj: {},
      dateList: [
        {
          name: '123',
          number: 112,
        },
        {
          name: '123',
          number: 112,
        },
        {
          name: '123',
          number: 112,
        },
      ],
      //结账金额
      payTableNum: '',
      //流水号输入框聚焦
      lsflag: false,
      jzmoney: '',
      showUnLink: true,
      imgBaseurl: 'http://pmsoss.rooibook.com/',
      orderMenus: [],
      Effective: '1',
      Effective1: false,
      //账单数据
      orderObj: {},
      bottomRightDiv: ['点菜', '结账'],
      bottomleftDiv: ['销单', '联单', '挂单', '追回', '分单', '账单'],
      twchecked: false,
      itemchecked: false,
      dieOrder: false,
      SingleCopy: false,
      //联单数组
      SingleCopyData: [],
      discountAndGift: '折扣',
      keyboardList: [],
      bzinput1: '',
      lsinput2: '',
      jzmoney: '',
      CashBack: false,
      payDialog: false,
      SalesOrder: false,
      passwordDialog: false,
      billDialog: false,
      //打折模式弹框
      discountflag: false,
      discount: false,
      numberValidateForm: {
        age: '',
      },
      returnFoodNum: '',
      methodItem: [],
      paytableData: [],
      nowTime: '11111',

      payOrderNum: '',
      timeradio: '到期停止',
      timeradio1: 'true',
      direction: 'ltr',
      timechecked: false,
      guesttableData: [],
      returnCurrent: 0,
      ChongFoodCurrent: 0,
      ARDialog: false,
      messageDrawer: false,
      readyTime: false,
      saleFood: false,
      SalerDialog: false,
      changeFood: false,
      addFood: false,
      returnFood: false,
      chongFood: false,
      changechannel: false,
      waiterDialog: false,
      peopleDialog: false,
      serviceDialog: false,
      guestDialogs: false,
      guestDialog: false,
      vipDialog: false,
      vipList: [],
      vipinput: '',
      roomSearchDialog: false,
      SaleFoodNum: '0.00',
      changeFoodNum: 1,
      addFoodNum: '',
      changechannelinput: '',
      flag: false,
      funcBtnShow: 0,
      // funcBtnList: ["计时", "改数量", "折扣", "赠送", "加菜", "冲菜", "退菜"],
      funcBtnList: ['折扣', '改数量', '改菜名', '改价格', '加菜', '冲菜', '退菜'],

      returnFoodList: ['输错单', '估清', '菜品质量问题', '其他问题', '测试'],
      ChongFoodList: ['输错单', '估清', '菜品质量问题', '其他问题', '测试'],
      saleFoodList: ['全单折扣', '会员折扣', '正常折扣', '其他折扣'],
      status: 1,
      radio: 3,
      radio1: '菜品详情',
      // 备注
      JSvalue: '',
      value: '',
      checkedChange: [],
      ChongFoodValue: '',
      options: [],
      funcBtnobj: [],
      nowID: '',
      nowstatus: '',
      alltotalPrice: 0,
      routeStatus: 0,
      cxrefund: false,
      allNum: 0,
      ARtableData: [],
      ARinput: '',
      arObj: {},
      vipObj: {},
      arlist: [],
      vipList: [],
      itemKey: 12,
      payobj: {},
      fetchLinkList: [],
      fetchLinknumber: 0,
      //点菜按钮 数字按钮
      rightBtnnumber: 0,
      discountList: [],
      dialogtitle: '',
      dialogtitleFlag: false,
      openwaiterflag: false,
      opensalesPersonflag: false,
      currentRow: '',
      openwaitername: '',
      takeoutdialog: false,
      remarkdialog: false,
      region: '',
      classBie: [],
      //打印机列表
      PDate: [],
      printName: '',
      menuTypeNameflag: false,
      openmealTableNumflag: false,
      updateFood: false,
      updatemoney: false,
      homeObj: '',
      //总控设备编码
      printPosCode: '',
      printerPosCodeObj: '',
      printNesObj: '',
      printNewObj: {},
      //1本机内置打印机 2总控打印机
      checkPrinter: '',
      //餐厅列表
      cantList: [],
      TableList: [], //桌子列表
      current: 0, //当前选中的餐桌
      openTableNumflag: false, //批量转菜弹窗
      transferMenusId: '', //当前选中的桌子
      dishesDiscountFlag: false,
      discountMoneys: 0,
      recoverFlag: false,
      isIndeterminate: true,
      checkAll: false,
      //当前选中的折扣模式
      discountObj: {
        disPro: '',
        remark: '',
        money: '',
      },
      singleDialog: false,
      singleList1: [],
      singleList2: [],
      singleList3: [],
      singleList4: [],
      //当前选中的数据的列表
      singleNumber: -1,
      singleChangeList: [],
      //默认分单数量
      singleNum: 2,
      singleList1Total: [],
      singleList2Total: [],
      singleList3Total: [],
      singleList4Total: [],
      //平分窗口开关
      averagelistDialog: false,
      //平分窗口->数量大于1的弹窗开关
      singleMoreListDialog: false,
      singleMoreList: [],
      //平分菜单数组
      averagelists: [],
      openTaiUstatus: {},
    };
  },
  components: {
    bill,
    print,
  },
  watch: {
    dcStatus(val) {
      this.dcStatus = val;
      console.log('dcStatus', this.dcStatus);
    },
    orderMenus(val) {
      // // console.log(val);
      this.alltotalPrice = 0;
      this.orderMenus = val;
      let total = 0;
      val.forEach(v => {
        // // console.log(v);
        total += v.allPrice;
        this.alltotalPrice = total;
      });
    },
    lsinput2(newVal, oldVal) {
      // console.log(newVal, oldVal);
      if (newVal !== oldVal) {
        setTimeout(() => {
          this.lsflag = false;
        }, 500);
      }
      if (this.lsflag) {
        this.loading('支付中');
        this.sweepPay();
      }
    },
  },
  computed: {
    sums: function () {
      let sums = [0, 0, 0, 0, 0, 0];
      if (this.orderMenus.length) {
        this.orderMenus.map(res => {
          sums[0] += res.quantity * 1;
          sums[1] += res.quantity * res.price * 1;
          sums[2] += res.discount * 1;
          sums[3] += res.serverPrice * 1;
          sums[4] += res.tax * 1;
          sums[5] += res.discountPrice * 1;
        });
      }
      // console.log(sums);
      return sums;
    },
  },
  created() {
    this.printPosCodes();
    this.mainPrinterPosCodes();
    // console.log(this.$route.path);
    if (this.$route.path == '/MenuQuery') {
      this.$store.commit('routePathMenuQuery');
    }
    if (this.$route.path == '/dashboard') {
      this.$store.commit('routePathDashboard');
    }
  },
  updated() {},
  mounted() {
    this.$bus.on('nowID', value => {
      // // console.log('nowIDnowIDnowIDnowID', value);
      this.nowID = value;
      console.log(value, 'value----nowID');
    });

    this.$bus.on('nowstatus', value => {
      this.nowstatus = value;
    });
    this.$bus.on('routeStatus', value => {
      this.routeStatus = value;
    });
    this.$bus.on('openTaiUstatus', value => {
      this.openTaiUstatus = value;
    });
    this.$bus.on('dishesCount', value => {
      this.$nextTick(() => {
        this.rightBtnnumber = value;
      });
    });

    this.$bus.on('orderMenu', value => {
      console.log('orderMenu', value);
      // this.routeStatus = value.orderMenus ? 1 : 0
      if (!value) {
        console.log('取消', 111);
        this.orderMenus = [];
        this.orderObj = {};
        this.$forceUpdate();

        return;
      }

      this.orderMenus = value.orderMenus || value.orderMenusMap;
      this.orderMenus.forEach(v => {
        this.$set(v, 'funcBtnShow', 0);
        this.$set(v, 'itemchecked', 0);
      });

      this.orderObj = value;
      console.log(this.orderObj, 'orderObj-------------------------11111111111');
      this.Effective = '1';
      this.twchecked = false;

      if (value.remark == '凉菜即起其他叫起') {
        this.radio = 3;
        this.paytableData.remark = '';
      } else if (value.remark == '全部叫起') {
        this.radio = 6;
        this.paytableData.remark = '';
      } else if (value.remark == '全部即起') {
        this.radio = 9;
        this.paytableData.remark = '';
      } else if (value.remark) {
        this.radio = 1;
        this.paytableData.remark = value.remark;
      } else {
        this.radio = 3;
        this.paytableData.remark = '';
      }

      let currentTime = DateUtils.formatDate(new Date(), 'yyyy-MM-dd');

      let date = new Date(value.businessDate);
      let time1 = date.getTime();
      let date1 = new Date(currentTime);
      let time2 = date1.getTime();
      if (time2 < time1) {
        //超过今天的订单不允许撤销结账
        // this.cxRefundFlag = false
      }
      // // console.log('orderMenu', this.orderMenus);
      // // console.log('this.orderObj', this.orderObj);
    });
  },
  methods: {
    fixAccount() {
      this.$confirm('此功能修复金额错误问题，请谨慎使用!', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          let methods = 'get';
          let url = this.api.accountRepair + '?id=' + this.orderObj.id;
          this.$axios({
            url,
            methods,
          }).then(res => {
            if (res.data.status == 0) {
              this.orderObj = res.data.data;
              this.$forceUpdate();
            }
          });
        })
        .catch(() => {});
    },
    closeprintFlag() {
      if (this.routeStatus == 0) {
        // localStorage.removeItem('openTaiUstatus')
        this.refund();
      }
    },
    formatSex(row) {
      return row.gender === 'M' ? '男' : row.gender === 'F' ? '女' : '未填写';
    },
    isUsed(row) {
      return row.is_used === 'U' ? '在用' : row.gender === 'I' ? '初始' : '未知';
    },
    //换桌号
    mealTableNumflag() {
      if (this.orderObj.status == 'O' || this.orderObj.status == 'C' || Object.keys(this.orderObj).length < 1) {
        return;
      }
      console.log(this.orderObj);
      this.openmealTableNumflag = true;
      this.openwaitername = '';
      this.getList('', '', localStorage.getItem('posCode'));
    },
    //批量转菜弹窗
    mealTableNumflags() {
      if (!this.checkedChange.length) {
        this.$message({
          message: '请先选择需要转的菜',
          type: 'error',
        });
        return;
      }
      if (this.orderObj.status == 'L') {
        this.$message({
          message: '当前菜单状态不满足转菜条件',
          type: 'error',
        });
        return;
      }

      this.openTableNumflag = true;
      // this.current = 0
      this.openwaitername = '';
      // console.log(this.checkedChange);
      this.getOutletsIdList();
      // this.getList(this.orderObj.mealTableId, '', localStorage.getItem('posCode'))
      // this.getList(this.orderObj.mealTableId, '', localStorage.getItem('posCode'))
    },
    //切换桌子
    currentCheck(v, i) {
      this.getList(v.id, '', localStorage.getItem('posCode'));
      // console.log(v);
      this.current = i;
    },
    selectopenTableList(v, i) {
      this.TableList.map(e => {
        if (e.id == v.id) {
          // console.log('true', e);
          // e.check = !e.check
          this.$set(e, 'check', true);

          this.transferMenusId = e.id;
        } else {
          this.$set(e, 'check', false);
        }
      });
    },
    //获取餐厅类型
    getOutletsIdList() {
      let methods = 'get';
      let url = this.api.getoutlets + '?posCode=' + localStorage.getItem('posCode');
      this.$axios({
        methods,
        url,
      }).then(res => {
        // console.log(res);
        this.cantList = [
          {
            description: '所有',
          },
        ];
        // console.log(4325435346,this.orderObj.mealTableName);

        res.data.data.forEach((v, i) => {
          this.cantList.push(v);
          console.log(4325435346, this.orderObj.restaurant, v);
          if (v.description == this.orderObj.restaurant) {
            this.current = i + 1;
            this.getList(v.id, '', localStorage.getItem('posCode'));
          }
        });
      });
    },

    //获取桌子
    getList(outletsId, queryLike, posCode) {
      this.fullscreenLoading = true;
      let methods = 'get';
      // let url = this.api.getTableList + '?outletsId='+outletsId+'&queryLike=' + queryLike + '&posCode=' + posCode
      let url = `${this.api.getTableList}?${outletsId ? 'outletsId=' : ''}${outletsId}&${queryLike ? 'queryLike=' : ''}${queryLike}&posCode=${posCode}`;
      const loading = this.$loading({
        lock: true,
        text: '加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });

      this.$axios({
        methods,
        url,
      })
        .then(res => {
          loading.close();
          // console.log(res.data);
          let arr = [],
            arr1 = [];

          res.data.data.map(e => {
            // console.log(e);
            if (e.statusCode == 'V') {
              arr.push(e);
            }
            arr1.push(e);
          });
          this.discountList = arr;
          this.TableList = arr1;
        })
        .catch(e => {
          loading.close();
        });
    },

    //修改类别
    updatemenuTypeName() {
      if (this.orderObj.status == 'O' || this.orderObj.status == 'C' || Object.keys(this.orderObj).length < 1) {
        return;
      }
      this.menuTypeNameflag = true;

      this.loading('加载中');
      let methods = 'get';

      let url = this.api.getDictDataList + '?dictTypeCode=PosMenuType';
      this.$axios({
        methods,
        url,
      }).then(res => {
        // console.log(res.data.data);
        res.data.data.map(v => {
          this.$set(v, 'check', false);
        });
        this.discountList = res.data.data;
      });
    },

    //获取当前电脑得打印机
    GetPrinter() {
      //获取当前打印机

      LODOP = getLodop();

      var iCount = LODOP.GET_PRINTER_COUNT();

      console.log(iCount, 'iCount-------');

      var PData = [];

      for (var i = 0; i < iCount; i++) {
        PData.push({
          code: i,
          name: LODOP.GET_PRINTER_NAME(i),
        });
        console.log(LODOP.GET_PRINTER_NAME(i), ' LODOP.GET_PRINTER_NAME(i)');
      }

      return PData;
    },
    changePDate(v) {
      // console.log('选择打印机', v);
      localStorage.setItem('printName', v);
      this.printName = v;
      // this.$refs.bill.getPrint()
    },
    //调用 打印账单
    ipadprint() {
      let url = this.api.orderMq;
      let methods = 'post';
      let obj = {
        data: JSON.stringify(this.printobj),
        isSingle: this.printerPosCodeObj[0].isSingle,
        printerId: this.printerPosCodeObj[0].printerId,
        description: this.printerPosCodeObj[0].description,
        type: this.printerPosCodeObj[0].type,
        ip: 'TCP:' + this.printerPosCodeObj[0].ip,
      };

      let data = {
        toipcName: this.printPosCode,
        status: 'Unprinted',
        hotelCode: localStorage.getItem('hotelCode'),
        type: 'order',
        value: JSON.stringify(obj),
      };
      this.$axios({
        url,
        methods,
        data,
      }).then(res => {
        console.log(res, '---12312321');
      });
    },
    //查询酒店打印主控点的设备编码
    printPosCodes() {
      let code = localStorage.getItem('hotelCode');
      let url = this.api.printPosCode + '?hotelCode=' + code;
      let methods = 'get';
      this.$axios({
        url,
        methods,
      }).then(res => {
        console.log(res, '查询酒店打印设备');
        this.printPosCode = res.data.data.printPosCode;
      });
    },
    //账单打印打印机信息
    mainPrinterPosCodes() {
      let code = localStorage.getItem('hotelCode');
      let url = this.api.mainPrinterPosCode + '?hotelCode=' + code;
      let methods = 'get';

      this.$axios({
        url,
        methods,
      }).then(res => {
        if (res.data.status == 0) {
          // console.log(res.data.data);

          this.printerPosCodeObj = res.data.data;

          // console.log('print', this.printerPosCodeObj);
        } else {
          this.$message({
            message: '获取打印机失败',
            type: 'error',
          });
        }
      });
    },
    ebounce(fn, wait) {
      let timeout = null;
      return function () {
        if (timeout !== null) clearTimeout(timeout);
        timeout = setTimeout(fn, wait);
      };
    },
    //打印
    printtable() {
      const loading = this.$loading({
        lock: true,
        text: '打印中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      setTimeout(() => {
        loading.close();
      }, 500);

      if (this.checkPrinter == 2) {
        this.ipadprint();
        this.$message({
          message: '已成功向总控打印机推送任务',
          type: 'success',
        });
      } else {
        // 本机打印
        if (!localStorage.getItem('printName')) {
          this.PDate = this.GetPrinter();
          this.$message({
            message: '请先选择打印机再打印',
            type: 'warning',
          });
        } else {
          // console.log('打印');
          this.$bus.$emit('printName', this.printName);

          this.$refs.billb.getPrint();
          this.$message({
            message: '已成功向本地打印机推送任务',
            type: 'success',
          });
          this.printFlag = false;

          // localStorage.removeItem('openTaiUstatus')
          if (this.routeStatus == 0) {
            this.refund();
          }
        }
      }
    },
    handleCurrent(v) {
      this.homeObj = v;
    },
    //结账收款按钮
    takeMoney() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });

      let url = this.api.posBill;
      let methods = 'post';
      let str = '';
      let type = '';
      let flag = false;
      let money = 0;
      this.paytableData.forEach(v => {
        // console.log(v);
        str += v.productName + ',';
        if (v.transactionId) {
          type = v.transactionId;
        }
        money += v.totalPrice * 1;

        if (v.productCode == '9005' && !v.transactionId) {
          flag = true;
        }
      });

      str = str.slice(0, str.length - 1);
      // console.log(money, this.alltotalPrice);
      // if (money != this.alltotalPrice) {
      //   this.$message({
      //     message: "结账金额有误",
      //     type: "error"
      //   })
      //   loading.close();
      //   return
      // }
      if (flag) {
        this.$notify.error({
          title: '微信付款失败',
        });
        loading.close();
        return;
      }

      let data = {
        checkType: str,
        orderRecordId: this.orderObj.id,
        orderNum: this.orderObj.orderNum,
        totalPrice: money,
        boList: this.paytableData,
      };
      // console.log('结账', data);
      this.$axios({
        url,
        methods,
        data,
      })
        .then(res => {
          // console.log(res);
          if (res.data.status == 0) {
            localStorage.removeItem('openTaiUstatus');

            this.payDialog = false;
            this.$notify.success({
              title: '结账成功',
            });

            this.printBillInfos();

            loading.close();
            this.refund();
            this.orderObj = '';
            this.printName = localStorage.getItem('printName');

            this.PDate = this.GetPrinter();

            this.billDialog = false;
          } else {
            this.$notify.error({
              title: res.data.message,
            });
            loading.close();
          }
        })
        .catch(() => {
          loading.close();
        });
    },

    handleCurrentChangeAR(v) {
      this.arObj = v;
    },
    handleCurrentChange1(v) {
      this.vipObj = v;
      this.integral = v.integral * 1;
      this.balance = v.balance * 1;
    },
    surfendchannelinput() {
      let url = this.api.posGetCustList;
      let methods = 'get';
      let data = {
        queryLike: this.changechannelinput,
        ctype: 'A',
      };
      this.$axios({
        url,
        methods,
        data,
      }).then(res => {
        // console.log('打折模式列表', res);
        // res.data.data.map(v => {
        //   this.$set(v, 'check', false)
        // })

        this.guesttableData = res.data.data;
      });
    },
    // 查询会员卡 确定按钮
    vipClick() {
      if (this.vipObj) {
        let num = 0;
        num = this.jzmoney;

        this.allNum = (this.allNum * 1 - this.jzmoney * 1).toFixed(2);
        this.jzmoney = this.allNum;
        let id = '';
        this.methodItem.map(e => {
          if (e.code_ == '9016') {
            id = e.id;
          }
        });

        this.paytableData.push({
          accountId: this.vipObj.accountId,
          accounname: this.vipObj.code,
          totalPrice: num,
          productCode: '9016',
          productName: '转会员',
          billType: 'M',
          productId: id,
        });

        this.vipDialog = false;
      } else {
        this.$notify.error({
          title: '请选择一个账户',
        });
      }
    },
    homeSearchClick() {
      let methods = 'get';
      let url = this.api.queryAccount;
      let data = {
        status: 'I',
      };
      if (this.changechannelinput) {
        data.queryLike = this.changechannelinput;
      }
      this.$axios({
        methods,
        url,
        data,
      }).then(res => {
        // console.log('房账', res);
        this.guesttableData = res.data.data;
      });
    },
    homeclick() {
      if (this.homeObj) {
        let num = 0;
        num = this.jzmoney;

        this.allNum = (this.allNum * 1 - this.jzmoney * 1).toFixed(2);
        this.jzmoney = this.allNum;

        this.paytableData.push({
          accountId: this.homeObj.id,
          accounname: this.homeObj.name,
          totalPrice: num,
          productCode: '10001',
          productName: '转房账',
          billType: 'H',
          productId: null,
        });

        this.roomSearchDialog = false;
      } else {
        this.$notify.error({
          title: '请选择一个账户',
        });
      }
    },
    vipCancleClick() {
      this.vipDialog = false;
    },
    arSearch() {
      this.arObj = '';
      let methods = 'get';
      let url = this.api.queryARAccount;
      let data = {
        type: 'AR',
        holdArrow: '1',
        key: this.ARinput,
      };
      this.$axios({
        methods,
        url,
        data,
      }).then(res => {
        // console.log(res);
        this.ARtableData = res.data.data;
        this.ARtableData.forEach((v, i) => {
          if (v.hold_arrow) {
            v.hold_arrow = '是';
          } else {
            v.hold_arrow = '否';
          }
        });
      });
      this.viplist.push({
        productId: v.id,
        productCode: v.code_,
        productName: v.name,
        remark: this.bzinput1,
        lsNum: this.lsinput2,
      });
    },
    Arcancleclick() {
      this.ARDialog = false;
    },

    //挂AR账 确定按钮
    Arclick() {
      if (this.arObj) {
        let num = 0;
        num = this.jzmoney;

        this.allNum = (this.allNum * 1 - this.jzmoney * 1).toFixed(2);
        this.jzmoney = this.allNum;
        let id = '';
        this.methodItem.map(e => {
          if (e.code_ == '9014') {
            // console.log(e);
            id = e.id;
          }
        });

        this.paytableData.push({
          accountId: this.arObj.id,
          accounname: this.arObj.code,
          totalPrice: num,
          productCode: '9014',
          productName: '转AR帐',
          billType: 'A',
          productId: id,
        });

        this.ARDialog = false;
      } else {
        this.$notify.error({
          title: '请选择一个账户',
        });
      }
    },
    //转会员
    VIPserch() {
      let methods = 'get';
      let url = this.api.posGetList;
      let data = {
        isUsed: 'U',
        moreParams: this.vipinput,
      };
      this.$axios({
        methods,
        url,
        data,
      }).then(res => {
        // console.log('会员', res);
        this.vipList = res.data.data;
      });
      this.arlist.push({
        productId: v.id,
        productCode: v.code_,
        productName: v.name,
        remark: this.bzinput1,
        lsNum: this.lsinput2,
      });
    },
    // 字典查询
    getDictDataList(dictTypeCode) {
      console.log('-----');
      let methods = 'get';
      let url = this.api.getDictDataList + '?dictTypeCode=' + dictTypeCode;
      this.$axios({
        methods,
        url,
      }).then(res => {
        // console.log(res);
        this.ChongFoodList = res.data.data;
        this.returnFoodList = res.data.data;
      });
    },
    reCalcOrder() {
      let data = {
        orderRecordId: this.orderObj.id,
        status: this.orderObj.status,
      };
      let methods = 'get';
      let url = this.api.reCalcOrder;
      this.$axios({
        methods,
        url,
        data,
      }).then(res => {
        console.log(res, '------');
        this.$emit('Success');
      });
    },
    // 结账付款 支付方式按钮
    methodClick(v) {
      if (this.orderObj.allPrice * 1 != 0) {
        // console.log(1);

        if (this.jzmoney == 0) {
          this.$notify.error({
            title: '账已经结完了',
          });
          // console.log(2);

          return;
        }
      }

      if (v.code_ == '9014') {
        this.ARDialog = true;
        this.arObj = '';
        let methods = 'get';
        let url = this.api.queryARAccount;
        let data = {
          type: 'AR',
          holdArrow: '1',
          key: this.ARinput,
        };
        this.$axios({
          methods,
          url,
          data,
        }).then(res => {
          // console.log(res);
          this.ARtableData = res.data.data;
          this.ARtableData.forEach((v, i) => {
            if (v.hold_arrow) {
              v.hold_arrow = '是';
            } else {
              v.hold_arrow = '否';
            }
          });
        });
        this.viplist.push({
          productId: v.id,
          productCode: v.code_,
          productName: v.name,
          remark: this.bzinput1,
          lsNum: this.lsinput2,
        });
        return;
      } else if (v.code_ == '9016') {
        this.vipDialog = true;

        this.vipObj = '';
        this.balance = 0;
        this.integral = 0;
        let methods = 'get';
        let url = this.api.posGetList;
        let data = {
          isUsed: 'U',
          moreParams: this.vipinput,
        };
        this.$axios({
          methods,
          url,
          data,
        }).then(res => {
          // console.log('会员', res);
          this.vipList = res.data.data;
        });
        this.arlist.push({
          productId: v.id,
          productCode: v.code_,
          productName: v.name,
          remark: this.bzinput1,
          lsNum: this.lsinput2,
        });
        return;
      } else if (v.code_ == '10001') {
        this.changechannelinput = '';
        this.roomSearchDialog = true;
        let methods = 'get';
        let url = this.api.queryAccount;
        let data = {
          status: 'I',
          roomNum: null,
          queryLike: this.changechannelinput ? this.changechannelinput : null,
        };

        this.$axios({
          methods,
          url,
          data,
        }).then(res => {
          // console.log('房账', res);
          this.guesttableData = res.data.data;
        });
        // this.arlist.push({
        //   productId: v.id,
        //   productCode: v.code_,
        //   productName: v.name,
        //   remark: this.bzinput1,
        //   lsNum: this.lsinput2,
        // })
        return;
      }

      if (this.jzmoney != 0 || this.orderObj.allPrice * 1 == 0) {
        // console.log('计算前的价格', this.jzmoney, this.allNum);

        if (this.jzmoney * 1 > this.allNum * 1) {
          this.$notify.error({
            title: '结账金额不能大于商品总金额',
          });

          return;
        }

        let num = 0,
          sweepPay,
          payType;
        num = this.jzmoney;
        this.allNum = (this.allNum - this.jzmoney).toFixed(2);
        this.jzmoney = this.allNum;
        // console.log('计算后的价格', this.jzmoney, this.allNum);

        if (v.name == '微信') {
          this.lsinput2 = '';
          sweepPay = '微信';
          payType = 'online';
          this.$nextTick(() => {
            this.$refs.gain.focus();
          }, 100);
          setTimeout(() => {
            this.lsflag = true;
          }, 500);
        }

        this.paytableData.push({
          productId: v.id,
          productCode: v.code_,
          productName: v.name,
          totalPrice: num,
          // accountId: '',
          // accounname: this.arObj.name,
          remark: this.bzinput1,
          // lsNum: this.lsinput2,
          billType: 'O',
          transactionId: '',
          pay: false,
          sweepPay,
          payType,
        });
      } else {
        this.$notify.error({
          title: '账已经结完了',
        });
        return;
      }
    },
    //结账付款关闭按钮
    beforeClose() {
      this.payDialog = false;
      this.bzinput1 = '';
    },
    //loading
    loading(text) {
      const loading = this.$loading({
        lock: true,
        text: text,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      setTimeout(() => {
        loading.close();
      }, 2000);
    },
    //调用扫码器支付
    sweepPay() {
      let auth_code = this.lsinput2;
      // let total_fee = this.jzmoney*100
      let total_fee = 1;
      let productName = this.payOrderNum;
      // console.log(123, auth_code, total_fee, productName);

      let methods = 'get';
      //total_fee支付总金额（单位：分）只能是整数
      //productName 支付的商品名称
      //auth_code 扫码器自动生成的编码
      let url = `${this.api.sweepPay}?total_fee=${total_fee}&productName=${productName}&auth_code=${auth_code}`;
      this.$axios({
        methods,
        url,
      }).then(res => {
        // console.log(res);
        this.paytableData[this.paytableData.length - 1].accounname = auth_code;
        this.paytableData[this.paytableData.length - 1].transactionId = res.data.data.transaction_id;

        // console.log(this.paytableData);
        this.itemKey = Math.random();
        this.lsinput2 = '';
        this.bzinput1 = '';
      });
    },

    deleteRow(index, rows, row) {
      //行数据
      // console.log(index, row);
      this.allNum = Number(this.allNum) + Number(row.totalPrice);
      this.jzmoney = this.allNum;

      /*  rows.forEach((v, i) => {
         if (index == i) {
           // console.log(v.money);
           // console.log(this.allNum);
         }
 
       }) */
      rows.splice(index, 1);
    },
    // 改数量
    changeNum() {
      if (this.changeFoodNum * 1 <= 0) {
        this.$message({
          message: '数量不能小于零',
          type: 'error',
        });

        return;
      }

      let url = this.api.updateQuantity + '?id=' + this.funcBtnobj.id + '&quantity=' + this.changeFoodNum,
        methods = 'get',
        data = {
          id: this.funcBtnobj.id,
          quantity: this.changeFoodNum,
        };
      this.$axios({
        url,
        methods,
      }).then(res => {
        // console.log(res);
        if (res.data.status == 0) {
          this.changeFood = false;
          this.$notify.success({
            title: '更改成功',
          });

          this.refund();
        } else {
          this.$notify.error({
            title: res.data.message,
          });
        }
      });
    },
    //本机打印数据处理函数
    demo(arr1, num) {
      let arr = [];
      // console.log('funcBtnobj', arr1, arr1.printer.length);
      if (arr1.printer.length) {
        // // console.log(1123);
        arr1.printer.map((n, m) => {
          if (arr1.is_kitchen_print) {
            const obj = {
              dishesName: this.funcBtnobj.dishesName,
              quantity: num * 1,
              unitName: this.funcBtnobj.unitName,
              printname: n.kitchenPrinterName,
              createDate: DateUtils.formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss'),
            };
            arr.push(obj);
          }
        });
      } else {
        return [];
      }

      return arr;
    },
    demoa(arr1) {
      // // console.log('第一步', arr1);
      let cache = {}; //存储的是键是zhuanye 的值，值是zhuanye 在indeces中数组的下标
      let indices = []; //数组中每一个值是一个数组，数组中的每一个元素是原数组中相同zhuanye的下标
      arr1.map((item, index) => {
        let printname = item.printname;
        let _index = cache[printname];
        if (_index !== undefined) {
          indices[_index].push(index);
        } else {
          cache[printname] = indices.length;
          indices.push([index]);
        }
      });
      let result = [];
      indices.map(item => {
        // // console.log(item);

        item.map(index => {
          // // console.log(index);

          result.push(arr1[index]);
        });
      });

      return result;
    },
    async demoaaa(arr) {
      // console.log('开始', arr);

      let oldname = '',
        newname,
        arr1 = [];
      arr1.push(arr[0]);
      if (arr.length == 1) {
        this.name = arr[0].printname;
        this.printlists = [...arr];
        // console.log(this.name, this.printlists);
        this.$nextTick(() => {
          // const ab = this.todoPrint(arr[0].printname, arr)
          this.printNewObj.orderMenusMap = arr1;

          this.ipadprinttable(this.printNewObj);
        });
        return;
      }

      for (let i = 1; i < arr.length; i++) {
        oldname = arr[0].printname;
        newname = arr[i].printname;
        // console.log('newname', oldname, newname);
        if (oldname == newname) {
          arr1.push(arr[i]);
          if (i == arr.length - 1) {
            this.name = newname;
            this.printlists = [...arr1];
            // console.log('打印', this.printlists);

            this.$nextTick(() => {
              // const ab = this.todoPrint(oldname, arr1)
              this.printNewObj.orderMenusMap = arr1;

              this.ipadprinttable(this.printNewObj);
            });
          }
        } else if (oldname != newname) {
          this.name = oldname;
          this.printlists = [...arr1];
          // console.log('打印', this.printlists);

          this.$nextTick(() => {
            // const ab = this.todoPrint(oldname, arr1)
            this.printNewObj.orderMenusMap = arr1;

            this.ipadprinttable(this.printNewObj);
          });

          const a = arr.slice(i);
          setTimeout(() => {
            this.demoaaa(a);
          }, 500);
          break;
        }
      }
    },
    //ipad打印加菜 退菜
    ipadprinttable(val) {
      let url = this.api.orderMq;
      let methods = 'post';
      let obj = {
        data: JSON.stringify(val),
      };
      let data = {
        toipcName: this.printPosCode,
        status: 'Unprinted',
        type: 'menu',
        hotelCode: localStorage.getItem('hotelCode'),
        value: JSON.stringify(obj),
      };
      this.$axios({
        url,
        methods,
        data,
      }).then(res => {
        // console.log(res);
      });
    },
    // 加菜
    addfoodCLick() {
      this.buttonLoading = true;

      if (this.addFoodNum <= 0) {
        this.$notify.error({
          title: '数量不能小于零',
        });
        this.buttonLoading = false;
        return;
      }
      let url = this.api.addMenu + '?id=' + this.funcBtnobj.id + '&quantity=' + this.addFoodNum,
        methods = 'get';
      this.$axios({
        url,
        methods,
      }).then(res => {
        // console.log(res);
        if (res.data.status == 0) {
          //pos 打印
          this.funcBtnobj.quantity = this.addFoodNum * 1;
          this.funcBtnobj.printHeader = '【加菜】';
          this.printNewObj = JSON.parse(JSON.stringify(this.orderObj));

          this.printNewObj.printHeader = '【加菜】';

          // this.ipadprinttable()

          const arr1 = this.demo(this.funcBtnobj, this.addFoodNum);

          const arr2 = this.demoa(arr1);
          this.demoaaa(arr2);
          // 本机打印
          // const arr1 = this.demo(this.funcBtnobj, this.addFoodNum)

          // const arr2 = this.demoa(arr1)
          // if (arr2.length) {
          //   this.$nextTick(() => {
          //     // console.log('printlist', arr2);

          //     this.$bus.emit('printlist', arr2)

          //     this.$bus.emit('name', '加菜')

          //   }, 500);
          //   // console.log('第三步', arr2);
          //   this.$refs.print.print()
          // }

          this.addFood = false;
          this.$notify.success({
            title: '更改成功',
          });
          // this.orderMenus.push(res.data.data)
          this.buttonLoading = false;

          this.refund();
        } else {
          this.$notify.error({
            title: res.data.message,
          });

          this.buttonLoading = false;
        }
      });
    },
    // 刷新
    refund() {
      this.orderMenus = [];
      this.openwaitername = '';
      if (this.routeStatus == 1) {
        this.$bus.$emit('cxRefund', this.nowID);
      } else {
        this.$emit('Success');
      }
    },
    //批量冲菜
    chongBTNS() {
      let ids = [];
      this.checkedChange.map(e => {
        ids.push(e.id);
      });
      // console.log(this.checkedChange, ids);
      let text = this.ChongFoodValue ? this.ChongFoodValue : this.ChongFoodList[0].description;
      let url = this.api.punchingMenuAll + '?ids=' + ids + '&status=X&remark=' + text,
        methods = 'delete';

      this.$axios({
        url,
        methods,
      }).then(res => {
        // console.log(res);
        if (res.data.status == 0) {
          this.$message({
            message: '批量冲菜成功',
            type: 'success',
          });
          this.refund();
          this.buttonLoading = false;
          this.chongFood = false;
        }
      });
    },
    //冲菜
    chongBTN() {
      this.buttonLoading = true;
      // console.log(this.ChongFoodValue);
      let id = [];
      if (this.checkedChange.length) {
        this.chongBTNS();
        return;
      }
      let url = this.api.punchingMenu,
        methods = 'delete',
        data = {
          id: this.funcBtnobj.id,
          status: 'X',
          remark: this.ChongFoodValue ? this.ChongFoodValue : this.ChongFoodList[0].description,
        };
      this.$axios({
        url,
        methods,
        data,
      }).then(res => {
        // console.log(res);
        if (res.data.status == 0) {
          this.chongFood = false;
          this.$notify.success({
            title: '更改成功',
          });
          this.orderMenus.forEach((v, i) => {
            if (v.id == this.funcBtnobj.id) {
              this.orderMenus.splice(i, 1);
            }
          });
          this.buttonLoading = false;
          this.refund();
        } else {
          this.$notify.error({
            title: res.data.message,
          });
          this.buttonLoading = false;
        }
      });
    },
    // 退菜
    returnClick() {
      this.buttonLoading = true;
      if (this.returnFoodNum > this.funcBtnobj.quantity) {
        this.$notify.error({
          title: '退菜数量不能大于本身',
        });
        this.buttonLoading = false;
        return;
      }
      if (!this.returnFoodNum) {
        this.$message({
          message: '请输入退菜数量',
          type: 'error',
        });
        this.buttonLoading = false;

        return;
      }

      if (this.returnFoodNum * 1 < 0) {
        this.$message({
          message: '请输入正确的数量',
          type: 'error',
        });
        this.buttonLoading = false;

        return;
      }
      let url = this.api.punchingMenu,
        methods = 'delete',
        data = {
          id: this.funcBtnobj.id,
          status: 'F',
          remark: this.ChongFoodValue ? this.ChongFoodValue : this.returnFoodList[0].description,
          quantity: this.returnFoodNum,
        };
      this.loading('退菜中');
      this.$axios({
        url,
        methods,
        data,
      })
        .then(res => {
          // console.log(res);
          this.buttonLoading = false;

          if (res.data.status == 0) {
            //pos 打印
            this.funcBtnobj.quantity = this.returnFoodNum * 1;
            this.funcBtnobj.printHeader = '【退菜】';
            this.printNewObj = JSON.parse(JSON.stringify(this.orderObj));
            // this.printNewObj.orderMenusMap = []
            this.printNewObj.printHeader = '【退菜】';
            // this.printNewObj.orderMenusMap[0] = this.funcBtnobj
            const arr1 = this.demo(this.funcBtnobj, this.returnFoodNum);

            const arr2 = this.demoa(arr1);
            this.demoaaa(arr2);
            // this.ipadprinttable()
            // const arr1 = this.demo(this.funcBtnobj, this.returnFoodNum)
            // const arr2 = this.demoa(arr1)
            // this.$nextTick(() => {
            //   this.$bus.emit('printlist', arr2)
            //   this.$bus.emit('name', '退菜')
            // }, 500);
            // // console.log('第三步', arr2);
            // this.$refs.print.print()
            let url = this.api.orderByTable;
            let methods = 'get';
            let data = {
              tableId: this.nowID,
              status: this.nowstatus,
            };
            this.$axios({
              url,
              methods,
              data,
            }).then(res => {
              // console.log('orderMenus', res.data);
              if (res.data.data) {
                this.orderMenus = res.data.data.orderMenusMap;
              }
              this.returnFood = false;
              this.$notify.success({
                title: '退菜成功',
              });
              this.refund();
            });
          } else {
            this.$notify.error({
              title: res.data.message,
            });
          }
        })
        .catch(e => {
          this.buttonLoading = false;
        });
    },
    //销单
    SalesOrderClick() {
      // console.log(this.ChongFoodValue);
      let url = this.api.cancell,
        methods = 'get',
        data = {
          orderRecordId: this.orderObj.id,
          remark: this.ChongFoodValue || this.ChongFoodList[0].description,
        };
      this.loading('销单中');

      this.$axios({
        url,
        methods,
        data,
      }).then(res => {
        // console.log(res);
        if (res.data.status == 0) {
          this.SalesOrder = false;
          this.$notify.success({
            title: '成功',
          });
          localStorage.removeItem('openTaiUstatus');
          this.$emit('Success');
        } else {
          this.$notify.error({
            title: res.data.message,
          });
        }
      });
    },
    //挂单
    dieOrderClick() {
      let url = this.api.onAccount,
        methods = 'get',
        data = {
          orderRecordId: this.orderObj.id,
        };
      this.loading('挂单中');

      this.$axios({
        url,
        methods,
        data,
      }).then(res => {
        if (res.data.status == 0) {
          this.dieOrder = false;
          if (this.routeStatus) {
            this.$bus.$emit('cxRefund', this.nowID);
          } else {
            this.$emit('Success');
          }
        }
      });
    },
    // 有效，所有
    changeEFF() {
      const loading = this.$loading({
        lock: true,
        text: '加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      let status = this.Effective == 1 ? 'I' : 'ALL';
      let url = '';
      if (this.routeStatus) {
        url = this.api.menuQueryInfoTo2 + '?orderRecordId=' + this.orderObj.id + '&status=' + status;
      } else {
        url = this.api.orderByTable + '?tableId=' + this.nowID + '&status=' + this.nowstatus + '&param=' + status;
      }

      let methods = 'get';

      this.$axios({
        url,
        methods,
      })
        .then(res => {
          // console.log(res);
          this.orderMenus = res.data.data.orderMenusMap;
          this.orderMenus.forEach(v => {
            this.$set(v, 'funcBtnShow', 0);
            this.$set(v, 'itemchecked', 0);
          });
          this.orderObj = res.data.data;
          loading.close();
        })
        .catch(e => {
          loading.close();
        });
    },
    // 联单多选框
    handleSelectionChange(val) {
      this.fetchLinkList = val;
    },
    changestatus() {
      if (this.radio1 == '菜品详情') {
        this.status = 1;
      } else if (this.radio1 == '餐单详情') {
        this.status = 2;
      } else if (this.radio1 == '结账明细') {
        this.$bus.emit('statuss', 2);
      }
    },
    // 结账收款按钮
    rightBtn(v, i) {
      if (!this.dcStatus) return;
      if (!this.orderObj.id) {
        this.$notify.error({
          title: '请先选择餐桌',
        });
        return;
      }

      if (v == '点菜') {
        // console.log(1);
        // let ids=JSON.parse(localStorage.getItem('openTaiUstatus '))
        // console.log(this.orderObj);
        let { href } = this.$router.resolve({
          path: '/order',
          query: {
            outletsId: this.openTaiUstatus.outletsId,
            id: this.orderObj.id,
          },
        });
        window.open(href, '_parent');
      } else if (v == '结账') {
        let flagss = false;
        this.orderMenus.map(e => {
          // console.log(2);
          if (e.allPrice == 0) {
            // console.log(1);
            flagss = true;

            this.$confirm('结账里有金额为0的项目, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            })
              .then(() => {
                flagss = false;
                this.payDialog = true;
              })
              .catch(() => {
                return;
              });
          }
        });
        let methods = 'get';
        let rounding = 2;
        //零头码功能，确定小数点位数
        // rounding; //四舍五入：1.十位  2.个位  3.小数点第一位  4.小数点第二位  5.小数点第三位
        this.$axios({
          url: this.api.zeroCodeByTable + '?mealTableId=' + this.nowID,
          methods,
        }).then(res => {
          if (res.data.status == 0) {
            // console.log(res.data);
            rounding = res.data.data.rounding;
          }
        });

        //支付方式图片
        const url = this.api.posProductPayList + '?posBill=Y';

        this.$axios({
          url,
          methods,
        }).then(res => {
          this.methodItem = res.data.data;
          this.methodItem.push({
            name: '转房账',
            code_: '10001',
            id: null,
          });
        });

        let data = {
          orderRecordId: this.orderObj.id,
          valid: 'Y',
        };

        this.$axios({
          url: this.api.bookBill,
          methods,
          data,
        }).then(res => {
          let num = 0;
          //预付款金额
          if (res.data.data.length > 0) {
            res.data.data.forEach(e => {
              this.paytableData.push(e);

              if (e.payOrRefund == 'pay') {
                num = num + e.totalPrice * 1;
              } else {
                num = num - e.totalPrice * 1;
              }
            });
          } else {
            num = 0;
          }

          console.log(12353452346, num);
          this.$nextTick(() => {
            this.alltotalPrice = this.orderObj.allPrice + this.orderObj.linkPrice - num;
            if (rounding == 1) {
              //  四舍五入：1.十位
              // 去除小数点后的数字
              let a = parseInt(this.alltotalPrice);
              // 取个位数
              let b = parseInt(a % 10);
              let c = parseInt(a / 10);
              this.alltotalPrice = b > 4 ? (c + 1) * 10 : c * 10;
            } else if (rounding == 2) {
              this.alltotalPrice = this.alltotalPrice.toFixed(0);
            } else if (rounding == 3) {
              this.alltotalPrice = this.alltotalPrice.toFixed(1);
            } else if (rounding == 4) {
              this.alltotalPrice = this.alltotalPrice.toFixed(2);
            }

            this.jzmoney = (this.alltotalPrice * 1).toFixed(2);
            this.allNum = this.jzmoney;
          });
        });

        if (!flagss) {
          this.payDialog = true;
        }
        this.payOrderNum = this.orderObj.orderNum;
        this.payTableNum = this.orderObj.mealTableNum;
        this.paytableData = [];
      }
    },
    // 撤销结账
    cxRefund() {
      // if (this.$store.state.currentTitle == 1) {

      //   return
      // }

      let currentTime = DateUtils.formatDate(new Date(), 'yyyy-MM-dd');
      var date = new Date(this.orderObj.businessDate);

      var time1 = date.getTime();

      var date1 = new Date(currentTime);
      //当前日期
      var time2 = date1.getTime();
      if (time2 == time1) {
        this.cxrefund = true;
      } else {
        this.$message({
          message: '不能对今天之前的订单撤销结账',
          type: 'warning',
        });
      }
    },
    // 撤销结账按钮
    cxrefundClick() {
      var url = this.api.revokePosBill + '?orderRecordId=' + this.orderObj.id;
      var methods = 'get';
      this.loading('加载中');
      this.$axios({
        url,
        methods,
      }).then(res => {
        if (res.data.status == 0) {
          this.$message({
            message: '撤销成功',
            type: 'success',
          });

          // this.dcStatus='S'
          this.$bus.$emit('cxRefund', this.nowID);
        } else {
          this.$notify.error({
            title: res.data.message,
          });
        }
        this.cxrefund = false;
      });
    },
    //判断账单打印机 是否为本机内置
    getCurPosSite() {
      let url = this.api.getCurPosSite;
      let methods = 'get';
      this.$axios({
        url,
        methods,
      }).then(res => {
        console.log(res.data, 'res----data');
        if (res.data.status == 0) {
          this.checkPrinter = res.data.data.checkPrinter;
          console.log('是否为本机内置', this.checkPrinter);
        }
      });
    },
    //账单数据
    printBillInfos() {
      this.loading('加载中');
      this.getCurPosSite();
      let url = this.api.printBillInfo + '?orderRecordId=' + this.orderObj.id;
      let methods = 'get';
      this.$axios({
        url,
        methods,
      }).then(e => {
        if (e.data.status == 0) {
          let num = 0,
            nums = 0;
          e.data.data.orderMenus.map(res => {
            num = num + res.total_price;
          });
          if (e.data.data.bills) {
            e.data.data.bills.map(ress => {
              nums = nums + ress.totalPrice * 1;
            });
          }

          // // console.log(nums);
          this.printobj = e.data.data;
          this.printobj.total_price = num;
          this.printobj.alls_price = nums;
          this.printName = localStorage.getItem('printName');
          // this.printPosCodes()
          // this.mainPrinterPosCodes()
          this.PDate = this.GetPrinter();

          this.printFlag = true;
        }
      });
    },
    // 底部按钮栏
    bottomleftDivCLick(v, i) {
      // console.log(v);
      let Status = this.routeStatus;
      if (v == '销单') {
        //       V,    "R",   "U",  "OO",  "D"，   L,   G,   C,    S,   O
        // <!-- 空闲","预订","开台","维修","脏台", 点菜，送单，消单，挂账，结账 -->
        if (this.orderObj.status == 'C' && this.orderObj.status == 'O' && this.orderObj.status == 'S' && this.orderObj.status == 'L') {
          return;
        }
        if (this.orderMenus.length == 0) {
          console.log('00000');
          this.SalesOrder = true;
          this.getDictDataList('PosCancleOrderReason');
        } else if (this.orderMenus.length) {
          let flag = true;
          for (let i = 0; i < this.orderMenus.length; i++) {
            if (this.orderMenus[i].status != 'F') {
              this.$message({
                message: '当前菜单不满足销单',
                type: 'error',
              });
              flag = false;
              break;
            }
          }
          if (flag) {
            this.SalesOrder = true;
            this.getDictDataList('PosCancleOrderReason');
          }
        }
      } else if (v == '挂单' && this.orderObj.status != 'U' && this.orderObj.status != 'O' && this.orderObj.status != 'S') {
        if (this.orderMenus.length == 0) {
          this.$message({
            message: '不满足挂单条件',
            type: 'error',
          });
        } else {
          this.orderMenus.map(e => {
            if (e.status != 'F' && e.status != 'X') {
              // console.log(e.status);
              this.dieOrder = true;
            }
          });
          if (!this.dieOrder) {
            this.$message({
              message: '不满足挂单条件',
              type: 'error',
            });
          }
        }
      } else if (v == '账单' && this.orderObj.status != 'U') {
        if (this.orderMenus.length) {
          this.printBillInfos();
        } else {
          this.$notify.error({
            title: '暂无账单',
          });
        }
      } else if (v == '联单' && this.orderObj.status != 'U' && this.orderObj.status != 'O' && this.orderObj.status != 'S') {
        this.openSingleCopy();
      } else if (v == '追回') {
        this.recoverFlag = true;
        // console.log(this.orderObj);
      } else if (v == '分单' && this.orderObj.status != 'O' && this.orderObj.status != 'C') {
        this.openSingleDialog();
      }
    },

    //打开联单弹窗
    openSingleCopy() {
      // console.log(this.orderObj);
      if (Object.keys(this.orderObj).length > 1 && this.orderObj.status != 'S' && this.orderObj.status != 'F' && this.orderObj.status != 'C' && this.orderObj.status != 'O') {
        this.SingleCopy = true;

        this.fetchLink(this.timeradio1);
      }
    },
    //追回按钮
    recoverOnclick() {
      let url = this.api.recover + '?orderRecordId=' + this.orderObj.id;
      let methods = 'get';
      this.$axios({
        url,
        methods,
      }).then(res => {
        // console.log('追回功能', res.data);
        if (res.data.status == 0) {
          this.$message({
            message: '追回成功',
            type: 'success',
          }),
            (this.recoverFlag = false);
          // this.refund()
          this.$bus.$emit('cxRefund', this.nowID);
        } else {
          this.$message({
            message: res.data.message,
            type: 'error',
          }),
            (this.recoverFlag = false);
        }
      });
    },
    // 获取联单列表
    fetchLink(e) {
      // console.log('fetchLink', e);
      let methods = 'get';
      let url = this.api.posLinkList;
      let data = {
        id: this.orderObj.id,
        showUnLink: e,
        linkNum: this.orderObj.linkNum,
      };
      this.loading('加载中');

      this.$axios({
        url,
        methods,
        data,
      }).then(res => {
        // console.log('联单列表', res);
        this.SingleCopyData = res.data.data;

        res.data.data.map(e => {
          if (e.link_num) {
            this.$nextTick(() => {
              this.$refs.SingleCopyData.toggleRowSelection(e, true);
              // console.log(e, this.fetchLinkList);
            });
          }
        });
      });
    },
    keyBoardClick(v) {
      // console.log(v);
      if (v == '清除') {
        this.addFoodNum = '';
      } else {
        this.addFoodNum += v;
      }
    },
    handleClose() {
      // console.log(1);
    },
    // 退菜选项选择
    checkReturnReason(v, i) {
      this.returnCurrent = i;
      this.ChongFoodValue = v.description;
      // console.log(this.ChongFoodValue);
    },
    checkChongFoodCurrent(v, i) {
      this.ChongFoodCurrent = i;

      this.ChongFoodValue = v.description;
      // console.log(this.ChongFoodValue);
    },
    // 单个选中下的按钮栏
    funcBtnclickItem(v, i, val) {
      // console.log('单个选中下的按钮栏', val, this.routeStatus);
      if (val) {
        this.funcBtnobj = val;
      }
      if (v == '加菜') {
        this.addFood = true;
      } else if (v == '改数量') {
        this.changeFoodNum = '';
        this.changeFood = true;
      } else if (v == '退菜') {
        this.getDictDataList('PosCancleOrderReason');
        this.returnFood = true;
        this.returnFoodNum = 1;
      } else if (v == '冲菜') {
        this.getDictDataList('PosCancleOrderReason');
        this.checkedChange = [];
        this.chongFood = true;
      } else if (v == '改菜名' && val.is_can_update_name) {
        this.updateFood = true;
        this.addFoodNum = '';
      } else if (v == '改价格' && val.is_can_update_price) {
        this.updatemoney = true;
        this.addFoodNum = '';
      } else if (v == '批量冲菜') {
        if (this.checkedChange.length && this.orderObj.status != 'L') {
          // console.log(this.checkedChange);
          let flags = false;
          this.checkedChange.map(res => {
            if (res.status == 'L') {
              flags = true;
            }
          });
          if (flags) {
            this.$message({
              message: '多选列表中，有未送单的的菜',
              type: 'error',
            });
            return;
          }
          this.getDictDataList('PosCancleOrderReason');
          this.chongFood = true;
        }
      } else if ((v == '折扣' && val.status == 'G') || val.status == 'S') {
        this.dishesDiscountFlag = true;
        this.discountMoneys = '';
        this.ChongFoodValue = '';
        this.ChongFoodCurrent = 0;
        this.discountSchemeLists();
      }
    },
    //优惠理由列表
    discountSchemeLists() {
      let url = this.api.discountSchemeList;
      let methods = 'get';
      this.$axios({
        url,
        methods,
      }).then(res => {
        if (res.data.status == 0) {
          // console.log(res.data.data);
          if (res.data.data.length) {
            res.data.data.map(e => {
              e.description = e.name;
            });
          }
          this.ChongFoodList = res.data.data;
        }
      });
    },
    //折扣率变化
    discountRateChange(val) {
      if (val == 1) {
        const reg = /^\d+(\.\d{0,2})?$/;
        // console.log(!reg.test(this.funcBtnobj.discountRate));

        if (!reg.test(this.funcBtnobj.discountRate) && this.funcBtnobj.discountRate) {
          this.$message({
            message: '请输入整数并最多两位小数',
            type: 'error',
          });
          this.funcBtnobj.discountRate = '';
          return;
        }
        this.discountMoneys = (this.funcBtnobj.totalPrice * 1 * this.funcBtnobj.discountRate).toFixed(2);
      } else {
        const reg = /^\d+(\.\d{0,2})?$/;
        if (!reg.test(this.discountMoneys) && this.discountMoneys) {
          this.$message({
            message: '请输入整数并最多两位小数',
            type: 'error',
          });
          this.discountMoneys = '';
          return;
        }
        // console.log(this.discountMoneys * 1, this.funcBtnobj.totalPrice, this.discountMoneys * 1 / this.funcBtnobj .totalPrice * 1);
        this.funcBtnobj.discountRate = (((this.discountMoneys * 1) / this.funcBtnobj.totalPrice) * 1).toFixed(2);
      }
    },
    //赠送按钮
    gift() {
      this.funcBtnobj.discountRate = 0;
      this.discountMoneys = 0;
    },
    //单菜折扣按钮
    givingDishes(val) {
      this.buttonLoading = true;

      let text = this.ChongFoodValue ? this.ChongFoodValue : null + this.funcBtnobj.discountReason ? this.funcBtnobj.discountReason : null;

      let discountRate = val == 0 ? 0 : this.funcBtnobj.discountRate;
      let url = '';
      if (text) {
        url = this.api.menuDiscount + '?id=' + this.funcBtnobj.id + '&discountRate=' + discountRate + '&discountReason=' + text;
      } else {
        url = this.api.menuDiscount + '?id=' + this.funcBtnobj.id + '&discountRate=' + discountRate;
      }
      // // // console.log(url);
      let methods = 'get';

      // return
      this.$axios({
        url,
        methods,
      })
        .then(res => {
          this.buttonLoading = false;
          if (res.data.status == 0) {
            // // console.log(res.data);
            this.$message({
              message: '打折成功',
              type: 'success',
            });
            this.dishesDiscountFlag = false;
            this.discountMoneys = '';
            this.ChongFoodCurrent = 0;
            this.refund();
          }
        })
        .catch(e => {
          this.buttonLoading = false;
        });
    },
    // 多选框
    itemcheckedChange(e, v, i) {
      // console.log(e, v, i);
      this.checkedChange = [];
      this.orderMenus.forEach(value => {
        if (value.itemchecked) {
          // this.$set(value, 'funcBtnShow', 1)
          this.$set(value, 'itemchecked', true);
          this.checkedChange.push(value);
        } else {
          // this.$set(value, 'funcBtnShow', 0)
          this.$set(value, 'itemchecked', false);
        }
      });
      this.checkAll = this.checkedChange.length === this.orderMenus.length;
      this.isIndeterminate = this.checkedChange.length > 0 && this.checkedChange.length < this.orderMenus.length;
    },
    //改菜名
    updateFoodClick() {
      let url = this.api.updateName + '?id=' + this.funcBtnobj.id + '&dishesName=' + this.addFoodNum;
      let methods = 'get';
      this.$axios({
        url,
        methods,
      }).then(res => {
        this.updateFood = false;
        this.addFoodNum = '';
        this.refund();
      });
    },
    updatemoneyClick() {
      let url = this.api.updatePrice + '?orderMenuId=' + this.funcBtnobj.id + '&price=' + this.addFoodNum;
      let methods = 'get';
      this.$axios({
        url,
        methods,
      }).then(res => {
        this.updatemoney = false;
        this.addFoodNum = '';
        this.refund();
      });
    },
    //点菜选中行
    checkItem(v, i) {
      // // console.log(this.orderMenus);//当前选中菜的数组
      //控制是否多选
      if (this.twchecked) {
        this.orderMenus.forEach((val, index) => {
          if (i == index) {
            if (val.funcBtnShow) {
              this.$set(val, 'funcBtnShow', 0);
              this.$set(val, 'itemchecked', false);
            } else {
              // val.itemchecked
              this.$set(val, 'funcBtnShow', 1);
              this.$set(val, 'itemchecked', true);
            }
          }
        });
        this.itemcheckedChange();
      } else {
        this.orderMenus.forEach((val, index) => {
          if (i == index) {
            if (val.funcBtnShow) {
              this.$set(val, 'funcBtnShow', 0);
            } else {
              this.$set(val, 'funcBtnShow', 1);
            }
          } else {
            this.$set(val, 'funcBtnShow', 0);
          }
        });
      }
    },
    //全选按钮
    handleCheckAllChange(val) {
      // console.log(val);
      if (!val) {
        this.orderMenus.map(res => {
          // this.$set(res, 'funcBtnShow', 0)
          this.$set(res, 'itemchecked', false);
        });
        this.checkedChange = [];
      } else {
        this.orderMenus.map(res => {
          // this.$set(res, 'funcBtnShow', 1)
          this.$set(res, 'itemchecked', true);
        });
        this.checkedChange = this.orderMenus;
      }

      this.isIndeterminate = false;
    },
    //联单
    SingleCopySure() {
      let arr = [];
      let flag = 0;
      this.fetchLinkList.map(e => {
        arr.push(e.id);
      });

      let url = this.api.orderRecordaddLink;
      let methods = 'post';
      let data = {
        id: this.orderObj.id,
        linkIds: arr,
      };
      // console.log('联单id', this.orderObj, data);
      this.loading('加载中');

      this.$axios({
        url,
        methods,
        data,
      }).then(res => {
        // console.log('联单列表', res);
        if (res.data.status == 0) {
          if (arr.length) {
            this.$message({
              message: '联单成功',
              type: 'success',
            });
          } else {
            this.$message({
              message: '取消成功',
              type: 'success',
            });
          }

          this.SingleCopy = false;
          this.refund();
        }
      });
    },
    //打折模式开关
    openbillDialog() {
      // console.log('openbillDialog', this.orderObj);
      if (this.orderObj.status == 'O' || this.orderObj.status == 'C' || Object.keys(this.orderObj).length < 1) {
        return;
      }
      let url = this.api.discountModel + '?orderRecordId=' + this.orderObj.id;
      let methods = 'get';
      this.loading('加载中');

      this.$axios({
        url,
        methods,
      }).then(res => {
        // console.log('打折模式列表', res.data.data);
        this.discountflag = true;
        res.data.data.map(v => {
          if (v.id == this.orderObj.discountModelId) {
            this.$set(v, 'check', true);
            v.dis_pro ? (this.discountObj.disPro = v.dis_pro) : '';
            v.remark ? (this.discountObj.remark = v.remark) : '';
            v.all_price ? (this.discountObj.money = v.all_price) : '';
            this.discountObj.discountModelId = v.id;
            this.discountObj.discountModelName = v.name;
            this.discountObj.orderRecordId = this.orderObj.id;
          } else {
            this.$set(v, 'check', false);
          }
        });
        this.discountList = res.data.data;
      });
    },
    //修改折扣模式
    selectdiscountItem(v, i) {
      this.discountList.map(e => {
        if (e.id == v.id) {
          this.$set(e, 'check', true);
          this.discountObj.discountModelId = v.id;
          this.discountObj.discountModelName = v.name;
          this.discountObj.orderRecordId = this.orderObj.id;
          this.discountObj.disPro = e.dis_pro ? v.dis_pro : '';
          this.discountObj.remark = e.remark ? v.remark : '';
          // console.log(this.discountList, this.discountObj);
        } else {
          this.$set(e, 'check', false);
        }
      });
    },
    //监听折扣率变化
    changeDisPro(val) {
      //  const reg = /^0\.[0-9]{0,2}$/

      const reg = /^\d+(\.\d{0,2})?$/;
      // console.log(!reg.test(val));

      if (!reg.test(val) && val) {
        this.$message({
          message: '请输入整数并最多两位小数',
          type: 'error',
        });
        this.discountObj.disPro = '';
        return;
      }
      this.discountObj.money = (val * this.orderObj.totalPrice * 1).toFixed(2);
    },
    //打折模式保存按钮
    discountprimary() {
      if (!this.discountObj.discountModelId) {
        this.$message({
          message: '请先选择打折模式',
          type: 'error',
        });
        return;
      }
      this.buttonLoading = true;
      let url = this.api.updateDiscount;
      let methods = 'post';
      let data = this.discountObj;
      this.$axios({
        url,
        methods,
        data,
      })
        .then(res => {
          this.buttonLoading = false;
          if (res.data.status == 0) {
            this.$message({
              message: '修改成功',
              type: 'success',
            });
            this.discountflag = false;

            this.refund();
          }
        })
        .catch(res => {
          this.buttonLoading = false;
        });
    },
    //修改服务员
    selectdiscountwaiterItem(v, i) {
      this.discountList.map(e => {
        if (e.id == v.id) {
          // console.log('true', e);
          this.$set(e, 'check', true);
          this.orderObj.waiter = {
            id: e.id,
            description: e.description,
          };
        } else {
          this.$set(e, 'check', false);
        }
      });
    },
    //修改销售员
    selectdiscountsalesPersonItem(v, i) {
      this.discountList.map(e => {
        if (e.id == v.id) {
          // console.log('true', e);
          e.check = !e.check;
          this.orderObj.salesPerson = {
            id: e.id,
            code: e.code,
            description: e.description,
          };
          // this.orderObj.discountModelId = e.id
        } else {
          this.$set(e, 'check', false);
        }
      });
    },
    //修改类别
    selectmenuTypeName(v, i) {
      this.discountList.map(e => {
        if (e.description == v.description) {
          // console.log('true', e);
          e.check = !e.check;
          this.orderObj.menuTypeCode = e.code;
          this.orderObj.menuTypeName = e.description;
          // this.orderObj.discountModelId = e.id
        } else {
          this.$set(e, 'check', false);
        }
      });
    },

    //打开服务员弹窗
    openwaiter() {
      if (this.orderObj.status == 'O' || this.orderObj.status == 'C' || Object.keys(this.orderObj).length < 1) {
        return;
      }
      this.openwaiterflag = true;
      let url = this.api.waiterlistByParam;
      let methods = 'get';
      let data = {
        description: this.openwaitername,
      };
      this.$axios({
        url,
        methods,
        data,
      }).then(res => {
        // console.log('打折模式列表', res);
        res.data.data.map(v => {
          this.$set(v, 'check', false);
        });
        this.discountList = res.data.data;
      });
    },
    //打开修改人数弹窗
    openPeopleDialog() {
      if (this.orderObj.status == 'O' || this.orderObj.status == 'C' || Object.keys(this.orderObj).length < 1) {
        return;
      }
      console.log(this.orderObj);
      this.peopleDialog = true;
    },
    //打开销售员弹窗
    opensalesPerson() {
      if (this.orderObj.status == 'O' || this.orderObj.status == 'C' || Object.keys(this.orderObj).length < 1) {
        return;
      }
      this.openwaitername = '';
      this.opensalesPersonflag = true;
      let url = this.api.listByParam;
      let methods = 'get';
      let data = {
        description: this.openwaitername,
      };
      this.$axios({
        url,
        methods,
        data,
      }).then(res => {
        // console.log('打折模式列表', res);
        res.data.data.map(v => {
          this.$set(v, 'check', false);
        });
        this.discountList = res.data.data;
      });
    },
    //销售员搜索
    opensalesPersons() {
      this.opensalesPersonflag = true;
      let url = this.api.listByParam;
      let methods = 'get';
      let data = {
        description: this.openwaitername,
      };
      this.$axios({
        url,
        methods,
        data,
      }).then(res => {
        // console.log('打折模式列表', res);
        res.data.data.map(v => {
          this.$set(v, 'check', false);
        });
        this.discountList = res.data.data;
      });
    },
    // 打开弹窗
    openprice(title) {
      this.dialogtitle = title;
      this.dialogtitleFlag = true;
      if (title == '服务费') {
        this.changeFoodNum = this.orderObj.serverPrice;
      }
      if (title == '税') {
        this.changeFoodNum = this.orderObj.tax;
      }
    },
    primarydialog() {
      if (this.dialogtitle == '服务费') {
        this.orderObj.serverPrice = this.changeFoodNum;
      }
      if (this.dialogtitle == '税') {
        this.orderObj.tax = this.changeFoodNum;
      }
      this.updateorderRecord();
    },
    //打开客户姓名弹窗
    openuserflag() {
      if (this.orderObj.status == 'O' || this.orderObj.status == 'C' || Object.keys(this.orderObj).length < 1) {
        return;
      }
      this.guestDialog = true;
      let url = this.api.posGetCustList;
      let methods = 'get';
      let data = {
        queryLike: this.changechannelinput,
        ctype: 'A',
      };
      this.$axios({
        url,
        methods,
        data,
      }).then(res => {
        // console.log('打折模式列表', res);
        // res.data.data.map(v => {
        //   this.$set(v, 'check', false)
        // })

        this.guesttableData = res.data.data;
      });
    },
    //打开修改外卖单号弹窗
    openTakeoutdialog() {
      if (this.orderObj.status == 'O' || this.orderObj.status == 'C' || Object.keys(this.orderObj).length < 1) {
        return;
      }
      console.log(this.orderObj);
      this.takeoutdialog = true;
    },
    //打开修改备注弹窗
    openRemarkDialog() {
      this.remarkdialog = true;
    },
    noneorderRecord() {
      this.refund();
      this.peopleDialog = false;
    },
    handleCurrentChange(val) {
      this.currentRow = val;
      // console.log(this.currentRow);
      this.orderObj.customer = {
        id: val.id,
        name: val.name,
      };
    },
    selectopenwaitername(v, i) {
      this.discountList.map(e => {
        if (e.id == v.id) {
          // console.log('true', e);
          // e.check = !e.check
          this.$set(e, 'check', true);

          this.orderObj.mealTableNum = e.code;
        } else {
          this.$set(e, 'check', false);
        }
      });
    },
    openmealTable(v) {
      // console.log(v);
      this.getList('', v, localStorage.getItem('posCode'));
    },
    updatemealTableNum() {
      this.discountList.map(e => {
        if (e.check) {
          // console.log(e);
          let url = this.api.changTable;
          let methods = 'get';
          let data = {
            orderRecordId: this.orderObj.id,
            tableId: e.id,
          };

          this.loading('加载中');
          this.$axios({
            url,
            methods,
            data,
          })
            .then(res => {
              // console.log(res);
              this.openmealTableNumflag = false;
              e.statusCode = this.orderObj.status;
              localStorage.setItem('openTaiUstatus', JSON.stringify(e));
              this.$bus.$emit('surfendTai', 1);
              // this.refund()
            })
            .catch(e => {
              // console.log(e);
            });
        }
      });
    },
    //修改保存接口】
    updateorderRecord() {
      let url = this.api.updateorderRecord;
      let methods = 'put';
      let data = this.orderObj;
      // console.log('updateorderRecord', this.orderObj);
      // return
      this.loading('加载中');

      this.$axios({
        url,
        methods,
        data,
      }).then(res => {
        // console.log('餐单详情修改接口', res);
        if (res.data.status == 0) {
          this.$notify.success({
            title: '修改成功',
          });
          // console.log(res.data.data);
          this.$nextTick(() => {
            this.orderObj = res.data.data;
          }, 500);
          this.refund();
          // this.orderMenus = res.data.data.orderMenusMap
          // res.data.data.orderMenusMap.map((e, i) => {
          //   this.$set(this.orderMenus, i, e)

          // })

          this.dialogtitleFlag = false;
          this.discountflag = false;
          this.openwaiterflag = false;
          this.opensalesPersonflag = false;
          this.peopleDialog = false;
          this.guestDialog = false;
          this.takeoutdialog = false;
          this.remarkdialog = false;
          this.menuTypeNameflag = false;
        }
      });
    },
    //多选按钮
    sureTwchecked() {
      !this.twchecked;
      this.orderMenus.map(val => {
        this.$set(val, 'funcBtnShow', 0);
        this.$set(val, 'itemchecked', false);
      });
      this.checkAll = false;
    },
    //取消多选
    cancelTwchecked() {
      this.twchecked = false;
      this.orderMenus.map(val => {
        this.$set(val, 'funcBtnShow', 0);
        this.$set(val, 'itemchecked', false);
      });
    },
    // 批量转菜
    transferMenus() {
      let url = this.api.transferMenus;
      let methods = 'post';
      let arr = [];
      this.checkedChange.map(e => {
        arr.push(e.id);
      });
      let data = {
        orderRecordId: this.orderObj.id,
        ids: arr,
        tableId: this.transferMenusId,
      };
      this.$axios({
        url,
        methods,
        data,
      }).then(res => {
        // console.log(res.data);
        if (res.data.status == 0) {
          this.$message({
            message: '转菜成功',
            type: 'success',
          });
          this.openTableNumflag = false;
          this.refund();
        }
      });
      // this.checkedChange //多选框数组
    },
    //打开分单弹窗
    openSingleDialog() {
      this.Effective = 1;
      this.changeEFF();
      this.singleDialog = true;
      this.singleList1 = this.orderMenus;
      this.singleList1Total = this.singleTotal(this.orderMenus);
      this.singleList1.map(res => {
        res.disable = false;
      });
      this.singleList2 = [];
      this.singleList3 = [];
      this.singleList4 = [];
      this.singleMoreList = [];
      this.singleNumber = 1;
      this.singleNum = 2;
      this.singleChangeList = [];
    },
    // 计算分单合计函数
    singleTotal(arr) {
      let sum = [0, 0, 0, 0];
      sum[0] = '合计';

      arr.map((item, index) => {
        sum[1] += item.quantity * 1;
        sum[2] += item.price * 1;
        sum[3] += item.totalPrice * 1;
      });

      // // console.log(arr, sum);
      sum[1] = (sum[1] * 1).toFixed(2);
      sum[2] = sum[2].toFixed(2);
      sum[3] = sum[3].toFixed(2);

      return sum;
    },
    //el-table 单击选中行
    toggleSelection(rows, e) {
      switch (e) {
        case 1:
          if (rows) {
            rows.forEach(row => {
              this.$refs.singleList1.toggleRowSelection(row);
            });
          } else {
            this.$refs.singleList1.clearSelection();
          }
          break;
        case 2:
          if (rows) {
            rows.forEach(row => {
              this.$refs.singleList2.toggleRowSelection(row);
            });
            // console.log(23, rows);
          } else {
            this.$refs.singleList2.clearSelection();
          }
          break;
        case 3:
          if (rows) {
            rows.forEach(row => {
              this.$refs.singleList3.toggleRowSelection(row);
            });
          } else {
            this.$refs.singleList3.clearSelection();
          }
          break;
        case 4:
          if (rows) {
            rows.forEach(row => {
              this.$refs.singleList4.toggleRowSelection(row);
            });
          } else {
            this.$refs.singleList4.clearSelection();
          }
          break;

        default:
          break;
      }
    },
    //点击复选框触发，复选框样式的改变
    singleSelectionChange(val, num) {
      // // console.log('选中的数据', val, num);
      if (num) {
        this.singleNumber = num;
      }
      this.singleChangeList = val;
    },
    //点击行触发，选中或不选中复选框
    handleRowClick(row, column, e, event) {
      if (this.singleNumber != event) {
        this.removerow(event);
        this.singleNumber = event;
      }
      let _selectData = '';
      switch (event) {
        case 1:
          this.$refs.singleList1.toggleRowSelection(row, event);
          // 获取当前选中的数据
          _selectData = this.$refs.singleList1.selection;
          // // console.log('获取当前选中的数据', _selectData);
          this.singleSelectionChange(_selectData);
          break;
        case 2:
          this.$refs.singleList2.toggleRowSelection(row, event);
          // 获取当前选中的数据
          _selectData = this.$refs.singleList2.selection;
          this.singleSelectionChange(_selectData);
          break;
        case 3:
          this.$refs.singleList3.toggleRowSelection(row, event);
          // 获取当前选中的数据
          _selectData = this.$refs.singleList3.selection;
          this.singleSelectionChange(_selectData);
          break;
        case 4:
          this.$refs.singleList4.toggleRowSelection(row, event);
          // 获取当前选中的数据
          _selectData = this.$refs.singleList4.selection;
          this.singleSelectionChange(_selectData);
          break;

        default:
          break;
      }
    },
    //给选中行染色
    singleClassNameList1({ row, rowIndex }) {
      let rowName = '';
      if (this.singleNumber == 1) {
        let findRow = this.singleChangeList.find(c => c.id === row.id);

        if (findRow) {
          rowName = 'success-row '; // elementUI 默认高亮行的class类 不用再样式了^-^,也可通过css覆盖改变背景颜色
        }
      }

      if (row.disable) {
        return 'error-row';
      } else {
        return rowName;
      } //也可以再加上其他类名 如果有需求的话
    },
    singleClassNameList2({ row, rowIndex }) {
      let rowName = '',
        findRow = this.singleChangeList.find(c => c.id === row.id);

      if (this.singleNumber == 2) {
        if (findRow) {
          rowName = 'success-row '; // elementUI 默认高亮行的class类 不用再样式了^-^,也可通过css覆盖改变背景颜色
        }
      }
      if (row.disable) {
        return 'error-row';
      } else {
        return rowName;
      } //也可以再加上其他类名 如果有需求的话
    },
    singleClassNameList3({ row, rowIndex }) {
      let rowName = '',
        findRow = this.singleChangeList.find(c => c.id === row.id);

      if (findRow && this.singleNumber == 3) {
        rowName = 'success-row '; // elementUI 默认高亮行的class类 不用再样式了^-^,也可通过css覆盖改变背景颜色
      }
      if (row.disable) {
        return 'error-row';
      } else {
        return rowName;
      } //也可以再加上其他类名 如果有需求的话
    },
    singleClassNameList4({ row, rowIndex }) {
      let rowName = '',
        findRow = this.singleChangeList.find(c => c.id === row.id);

      if (findRow && this.singleNumber == 4) {
        rowName = 'success-row '; // elementUI 默认高亮行的class类 不用再样式了^-^,也可通过css覆盖改变背景颜色
      }
      if (row.disable) {
        return 'error-row';
      } else {
        return rowName;

        //也可以再加上其他类名 如果有需求的话
      }
    },
    selectable(row, index) {
      if (row.disable) {
        return false; //禁用状态
      } else {
        return true; //非禁用状态
      }
    },

    handleRowAllClick(val, event) {
      // console.log('全选按钮', val, event);
      this.singleNumber = event;
    },
    rowStyle({ row, rowIndex }) {},
    //增加?减少 分单数量
    singleNumberBtn(val) {
      if (val) {
        this.singleNum++;
      } else {
        if (this.singleNum == 3 && this.singleList3.length > 0) {
          this.$message({
            message: '当前分单列表有数据，不能减少',
            type: 'warning',
          });
          return;
        } else if (this.singleNum == 4 && this.singleList4.length > 0) {
          this.$message({
            message: '当前分单列表有数据，不能减少',
            type: 'warning',
          });
          return;
        } else {
          this.singleNum--;
        }
      }
    },
    // 平分移动
    removerow(val) {
      let index = this.singleNumber;

      this.singleChangeList.map((res, i) => {
        if (res.disable) {
          this.singleChangeList.splice(i, 1);
        }
      });

      //index 选中的数组
      //VAL 添加的数组
      // console.log(11111,val,index,this.singleChangeList);
      if (val != index) {
        let arr = [];
        this.singleMoreList = [];
        this.singleChangeList.map((res, i) => {
          if (res.quantity * 1 > 1) {
            // console.log('大于',res);
            this.$set(res, 'Numbers', '');
            this.$set(res, 'location', val);
            this.$set(res, 'dis', true);
            this.singleMoreList.push(res);
          } else {
            // console.log('小于',res);

            arr.push(res);
          }
        });
        // 添加数据
        if (val == 1) {
          let flag = false;
          //判断是否有重复值
          arr.map((res, i) => {
            this.singleList1.map(e => {
              if (e.id == res.id) {
                e.quantity = e.quantity * 1 + res.quantity * 1;
                e.totalPrice = e.totalPrice * 1 + res.totalPrice * 1;
                // arr.splice(i, 1)
                flag = true;
              }
            });
          });
          if (!flag) {
            this.singleList1.push.apply(this.singleList1, arr);
          }

          this.singleList1Total = this.singleTotal(this.singleList1);
        } else if (val == 2) {
          let flag = false;
          arr.map((res, i) => {
            this.singleList2.map(e => {
              if (e.id == res.id) {
                e.quantity = e.quantity * 1 + res.quantity * 1;
                e.totalPrice = e.totalPrice * 1 + res.totalPrice * 1;
                // arr.splice(i, 1)
                flag = true;
              }
            });
          });
          if (!flag) {
            this.singleList2.push.apply(this.singleList2, arr);
          }
          this.singleList2Total = this.singleTotal(this.singleList2);
        } else if (val == 3) {
          let flag = false;
          arr.map((res, i) => {
            this.singleList3.map(e => {
              if (e.id == res.id) {
                e.quantity = e.quantity * 1 + res.quantity * 1;
                e.totalPrice = e.totalPrice * 1 + res.totalPrice * 1;
                // arr.splice(i, 1)
                flag = true;
              }
            });
          });
          if (!flag) {
            this.singleList3.push.apply(this.singleList3, arr);
          }
          this.singleList3Total = this.singleTotal(this.singleList3);
        } else if (val == 4) {
          let flag = false;

          arr.map((res, i) => {
            this.singleList4.map(e => {
              if (e.id == res.id) {
                e.quantity = e.quantity * 1 + res.quantity * 1;
                e.totalPrice = e.totalPrice * 1 + res.totalPrice * 1;
                // arr.splice(i, 1)
                flag = true;
              }
            });
          });
          if (!flag) {
            this.singleList4.push.apply(this.singleList4, arr);
          }
          this.singleList4Total = this.singleTotal(this.singleList4);
        }
        // // console.log('删除重复值',arr,index);
        //删除数据
        if (index == 1) {
          this.singleList1 = this.singleList1.filter(items => {
            if (!arr.includes(items)) return items;
          });
          this.singleList1Total = this.singleTotal(this.singleList1);
        } else if (index == 2) {
          this.singleList2 = this.singleList2.filter(items => {
            if (!arr.includes(items)) {
              return items;
            }
          });
          this.singleList2Total = this.singleTotal(this.singleList2);
        } else if (index == 3) {
          this.singleList3 = this.singleList3.filter(items => {
            if (!arr.includes(items)) {
              return items;
            }
          });
          this.singleList3Total = this.singleTotal(this.singleList3);
        } else if (index == 4) {
          this.singleList4 = this.singleList4.filter(items => {
            if (!arr.includes(items)) {
              return items;
            }
          });
          this.singleList4Total = this.singleTotal(this.singleList4);
        }

        //清空选中的数组
        this.singleChangeList = [];
        //有数量大于1 的菜品
        if (this.singleMoreList.length) {
          this.singleMoreListDialog = true;
        }
      }
    },
    // 分单 数量大于一的移动
    singleMoreSubmit() {
      if (this.singleMoreList.length) {
        let length = this.singleMoreList.length;
        let arr = this.singleMoreList;
        let arr1 = [],
          arr2 = [];
        let val = arr[0].location;
        let index = this.singleNumber;
        // // console.log(22222,val,index);
        for (let i = 0; i < length; i++) {
          const element = arr[i];
          if (element.Numbers * 1 > element.quantity * 1) {
            this.$message({
              message: '分单数量不能大于原单数量',
              type: 'warning',
            });
            return;
          } else if (!element.Numbers || element.Numbers * 1 == 0) {
            this.$message({
              message: '分单数量不能为空',
              type: 'warning',
            });
            return;
          } else {
            arr2.push(JSON.parse(JSON.stringify(element)));
            arr1.push(JSON.parse(JSON.stringify(element)));
          }
        }
        if (val == 1) {
          arr2.map((ress, i) => {
            let obj = '';
            obj = JSON.parse(JSON.stringify(ress));
            obj.quantity = obj.Numbers * 1;
            obj.totalPrice = (obj.Numbers * 1 * obj.price).toFixed(2);

            this.singleList1.map(e => {
              if (e.id == obj.id) {
                e.quantity = (e.quantity * 1 + obj.quantity * 1).toFixed(2);
                e.totalPrice = (e.totalPrice * 1 + obj.totalPrice * 1).toFixed(2);
                ress.dis = false;
                // console.log(e);
              }
            });
          });

          arr2.map(res => {
            let obj = res;
            obj = JSON.parse(JSON.stringify(obj));
            obj.quantity = obj.Numbers * 1;
            obj.totalPrice = (obj.Numbers * 1 * obj.price).toFixed(2);
            if (res.dis) {
              this.singleList1.push(obj);
            }
          });

          // this.singleList1.push.apply(this.singleList1, arr2)
          this.singleList1Total = this.singleTotal(this.singleList1);
        } else if (val == 2) {
          // this.singleList2.push.apply(this.singleList2, arr2);

          arr2.map((ress, i) => {
            let obj = '';
            obj = JSON.parse(JSON.stringify(ress));
            obj.quantity = obj.Numbers * 1;
            obj.totalPrice = (obj.Numbers * 1 * obj.price).toFixed(2);

            this.singleList2.map(e => {
              if (e.id == obj.id) {
                e.quantity = (e.quantity * 1 + obj.quantity * 1).toFixed(2);
                e.totalPrice = (e.totalPrice * 1 + obj.totalPrice * 1).toFixed(2);
                ress.dis = false;
                // console.log(e);
              }
            });
          });

          arr2.map(res => {
            let obj = res;
            obj = JSON.parse(JSON.stringify(obj));
            obj.quantity = obj.Numbers * 1;
            obj.totalPrice = (obj.Numbers * 1 * obj.price).toFixed(2);
            if (res.dis) {
              this.singleList2.push(obj);
            }
          });
          this.singleList2Total = this.singleTotal(this.singleList2);
        } else if (val == 3) {
          // this.singleList3.push.apply(this.singleList3, arr2);

          arr2.map((ress, i) => {
            let obj = '';
            obj = JSON.parse(JSON.stringify(ress));
            obj.quantity = obj.Numbers * 1;
            obj.totalPrice = (obj.Numbers * 1 * obj.price).toFixed(2);

            this.singleList3.map(e => {
              if (e.id == obj.id) {
                e.quantity = (e.quantity * 1 + obj.quantity * 1).toFixed(2);
                e.totalPrice = (e.totalPrice * 1 + obj.totalPrice * 1).toFixed(2);
                ress.dis = false;
                // console.log(e);
              }
            });
          });
          // console.log(arr2, this.singleList2);

          arr2.map(res => {
            let obj = res;
            obj = JSON.parse(JSON.stringify(obj));
            obj.quantity = obj.Numbers * 1;
            obj.totalPrice = (obj.Numbers * 1 * obj.price).toFixed(2);
            if (res.dis) {
              this.singleList3.push(obj);
            }
          });
          this.singleList3Total = this.singleTotal(this.singleList3);
        } else if (val == 4) {
          // this.singleList4.push.apply(this.singleList4, arr2);

          arr2.map((ress, i) => {
            let obj = '';
            obj = JSON.parse(JSON.stringify(ress));
            obj.quantity = obj.Numbers * 1;
            obj.totalPrice = (obj.Numbers * 1 * obj.price).toFixed(2);

            this.singleList4.map(e => {
              if (e.id == obj.id) {
                e.quantity = (e.quantity * 1 + obj.quantity * 1).toFixed(2);
                e.totalPrice = (e.totalPrice * 1 + obj.totalPrice * 1).toFixed(2);
                ress.dis = false;
                // console.log(e);
              }
            });
          });
          // console.log(arr2, this.singleList2);

          arr2.map(res => {
            let obj = res;
            obj = JSON.parse(JSON.stringify(obj));
            obj.quantity = obj.Numbers * 1;
            obj.totalPrice = (obj.Numbers * 1 * obj.price).toFixed(2);
            if (res.dis) {
              this.singleList4.push(obj);
            }
          });
          this.singleList4Total = this.singleTotal(this.singleList4);
        }

        //修改数据

        arr2.map(e => {
          switch (index) {
            case 1:
              this.singleList1.map((res, i) => {
                if (res.id == e.id) {
                  if (e.quantity * 1 - e.Numbers * 1 == 0) {
                    this.singleList1.splice(i, 1);
                  } else {
                    res.quantity = (e.quantity - e.Numbers * 1).toFixed(2);
                    res.totalPrice = (res.quantity * e.price * 1).toFixed(2);
                  }
                }
              });
              break;
            case 2:
              this.singleList2.map((res, i) => {
                if (res.id == e.id) {
                  if (e.quantity * 1 - e.Numbers * 1 == 0) {
                    this.singleList2.splice(i, 1);
                  } else {
                    res.quantity = (e.quantity - e.Numbers * 1).toFixed(2);
                    res.totalPrice = (res.quantity * e.price * 1).toFixed(2);
                  }
                }
              });
              break;
            case 3:
              this.singleList3.map((res, i) => {
                if (res.id == e.id) {
                  if (e.quantity * 1 - e.Numbers * 1 == 0) {
                    this.singleList3.splice(i, 1);
                  } else {
                    res.quantity = (e.quantity - e.Numbers * 1).toFixed(2);
                    res.totalPrice = (res.quantity * e.price * 1).toFixed(2);
                  }
                }
              });
              break;
            case 4:
              this.singleList4.map((res, i) => {
                if (res.id == e.id) {
                  if (e.quantity * 1 - e.Numbers * 1 == 0) {
                    this.singleList4.splice(i, 1);
                  } else {
                    res.quantity = (e.quantity - e.Numbers * 1).toFixed(2);
                    res.totalPrice = (res.quantity * e.price * 1).toFixed(2);
                  }
                }
              });
              break;
          }
        });

        this.singleList1Total = this.singleTotal(this.singleList1);
        this.singleList2Total = this.singleTotal(this.singleList2);
        this.singleList3Total = this.singleTotal(this.singleList3);
        this.singleList4Total = this.singleTotal(this.singleList4);
        this.singleMoreListDialog = false;
      }
    },
    averageDialog() {
      this.averagelistDialog = true;
      this.averagelists = [
        {
          check: false,
        },
        {
          check: false,
        },
        {
          check: false,
        },
        {
          check: false,
        },
      ];
    },
    singleSelectItem(e, i) {
      this.averagelists[i].check = !this.averagelists[i].check;
    },
    // 平分
    averagelist() {
      let selectNum = 0;

      this.averagelists.map(res => {
        if (res.check) {
          ++selectNum;
        }
      });

      if (selectNum < 2) {
        this.$message({
          message: '至少选择两个',
          type: 'error',
        });
        return;
      }
      let num = this.singleNum;
      if (this.singleChangeList.length) {
        //当前有几个分单页面

        //当前选中的数据为 第几个数组的内容
        let index = this.singleNumber;
        let arr = [];

        this.singleChangeList.map((e, i) => {
          e.quantity = (e.quantity / selectNum).toFixed(2);
          e.totalPrice = (e.totalPrice / selectNum).toFixed(2);
          e.disable = true;
          arr.push(e);
        });

        this.averagelists.map((item, j) => {
          if (item.check) {
            if (index != j + 1) {
              switch (j + 1) {
                case 1:
                  this.singleList1.push.apply(this.singleList1, this.singleChangeList);
                  break;
                case 2:
                  this.singleList2.push.apply(this.singleList2, this.singleChangeList);
                  break;
                case 3:
                  this.singleList3.push.apply(this.singleList3, this.singleChangeList);
                  break;
                case 4:
                  this.singleList4.push.apply(this.singleList4, this.singleChangeList);
                  break;
                default:
                  break;
              }
            } else {
              this.singleChangeList.map(e => {
                switch (index) {
                  case 1:
                    this.singleList1.map(res => {
                      if (res.id == e.id) {
                        res.quantity = e.quantity;
                        res.totalPrice = e.totalPrice;
                        res.disable = true;
                      }
                    });
                    break;
                  case 2:
                    this.singleList2.map(res => {
                      if (res.id == e.id) {
                        res.quantity = e.quantity;
                        res.totalPrice = e.totalPrice;

                        // res.allPrice = e.allPrice
                        res.disable = true;
                      }
                    });
                    break;
                  case 3:
                    this.singleList3.map(res => {
                      if (res.id == e.id) {
                        res.quantity = e.quantity;
                        res.totalPrice = e.totalPrice;

                        // res.allPrice = e.allPrice
                        res.disable = true;
                      }
                    });
                    break;
                  case 4:
                    this.singleList4.map(res => {
                      if (res.id == e.id) {
                        res.quantity = e.quantity;
                        res.totalPrice = e.totalPrice;
                        // res.allPrice = e.allPrice
                        res.disable = true;
                      }
                    });
                    break;
                }
              });
            }
          }
        });
        //判断平分数据 包不包含自身
        let some = this.averagelists.some((e, i) => {
          return e.check && i + 1 == index;
        });
        if (!some) {
          this.singleChangeList.map(e => {
            switch (index) {
              case 1:
                this.singleList1.map((res, i) => {
                  if (res.id == e.id) {
                    this.singleList1.splice(i, 1);
                  }
                });
                break;
              case 2:
                this.singleList2.map((res, i) => {
                  if (res.id == e.id) {
                    this.singleList2.splice(i, 1);
                  }
                });
                break;
              case 3:
                this.singleList3.map((res, i) => {
                  if (res.id == e.id) {
                    this.singleList3.splice(i, 1);
                  }
                });
                break;
              case 4:
                this.singleList4.map((res, i) => {
                  if (res.id == e.id) {
                    this.singleList4.splice(i, 1);
                  }
                });
                break;
            }
          });
        }

        //重新计算合计
        this.singleList1Total = this.singleTotal(this.singleList1);
        this.singleList2Total = this.singleTotal(this.singleList2);
        this.singleList3Total = this.singleTotal(this.singleList3);
        this.singleList4Total = this.singleTotal(this.singleList4);
      } else {
        this.$message({
          message: '请先选择需要分单的菜品',
          type: 'error',
        });
        return;
      }

      this.averagelistDialog = false;
      this.singleChangeList = [];
      //清空多选框
      this.$refs.singleList1.clearSelection();
      this.$refs.singleList2.clearSelection();
      if (num > 2) {
        this.$refs.singleList3.clearSelection();
      } else if (num > 3) {
        this.$refs.singleList4.clearSelection();
      }
      this.singleNumber = 0;
    },
    //重置分单
    resetList() {
      this.Effective = 1;
      this.changeEFF();
      this.singleList1 = this.orderMenus;
      this.singleList2 = [];
      this.singleList3 = [];
      this.singleList4 = [];
      this.singleMoreList = [];
      this.singleNumber = 1;
      this.singleNum = 2;
    },
    // 平分确定按钮
    splitMenu() {
      let num = this.singleNum;
      let data = {};
      if (num == 2) {
        if (!this.singleList2.length || !this.singleList2.length) {
          this.$message({
            message: '已选分单列表不能为空',
            type: 'warning',
          });
          return;
        } else {
          data = {
            orderRecordId: this.orderObj.id,
            oms1: this.singleList1,
            oms2: this.singleList2,
          };
        }
      } else if (num == 3) {
        if (!this.singleList2.length || !this.singleList2.length || !this.singleList3) {
          this.$message({
            message: '已选分单列表不能为空',
            type: 'warning',
          });
          return;
        } else {
          data = {
            orderRecordId: this.orderObj.id,
            oms1: this.singleList1,
            oms2: this.singleList2,
            oms3: this.singleList3,
          };
        }
      } else if (num == 4) {
        if (!this.singleList2.length || !this.singleList2.length || !this.singleList3 || !this.singleList4) {
          this.$message({
            message: '已选分单列表不能为空',
            type: 'warning',
          });
          return;
        } else {
          data = {
            orderRecordId: this.orderObj.id,
            oms1: this.singleList1,
            oms2: this.singleList2,
            oms3: this.singleList3,
            oms4: this.singleList4,
          };
        }
      }
      const url = this.api.splitMenu;
      const methods = 'post';

      this.buttonLoading = true;
      this.$axios({
        url,
        methods,
        data,
      })
        .then(res => {
          this.buttonLoading = false;
          if (res.data.status == 0) {
            this.$message({
              message: '分单成功',
              type: 'success',
            });
            this.singleDialog = false;
            this.refund();
          }
        })
        .catch(e => {
          this.buttonLoading = false;
        });
    },
    openLogDialog() {
      if (Object.keys(this.orderObj).length < 1) {
        return;
      }

      this.logDialog = true;
      let url = this.api.listPos + '?orderNum=' + this.orderObj.orderNum;
      let methods = 'get';

      this.$axios({
        url,
        methods,
      }).then(res => {
        this.discountList = res.data.data;
      });
    },
    Registration() {
      let methods = 'put';
      let url = this.api.bookRegister;
      this.loading('登记中');
      let data = {
        id: this.orderObj.id,
      };
      this.$axios({
        methods,
        url,
        data,
      })
        .then(res => {
          // console.log(res);
          // this.loading = false

          if (!res.data.status) {
            this.$message({
              message: '登记成功',
              type: 'success',
            });
            this.$bus.$emit('statusCode', 'U');
            this.refund();
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            });
          }
        })
        .catch(() => {});
    },
    cancellation() {
      this.$confirm('此操作将取消预订, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.loading('取消中');

          let methods = 'put';
          let url = this.api.bookCancel;
          let data = {
            id: this.orderObj.id,
          };
          this.$axios({
            methods,
            url,
            data,
          })
            .then(res => {
              if (!res.data.status) {
                this.$message({
                  message: '取消成功',
                  type: 'success',
                });
                this.refund();

                // this.qxStatus = 1
                // this.statusImg = 'X'
              } else {
                this.$notify.eror({
                  title: res.data.message,
                });
              }
            })
            .catch(() => {});
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.CTClassification {
  display: flex;
  // width: 100%;
  justify-content: left;

  border-bottom: 1px solid #eaeaea;
  padding: 13px;

  .ctItem {
    width: 130px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    border-radius: 20px;
    color: #666666;
    cursor: pointer;
  }

  .currentCT {
    background: #0099ff;
    color: #fff;
  }
}

.dontClick {
  // pointer-events: none;
}

.topView {
  height: 66px;
  width: 100%;
  border-bottom: 1px solid #eaeaea;
  padding: 0 10px;

  .Viewtitle {
    width: 100%;
    display: grid;
    grid-template-columns: 40px 150px 200px 1fr 180px;
    font-size: 16px;
    height: 100%;
    align-items: center;

    /deep/.el-checkbox__inner {
      width: 22px;
      height: 22px;
      border-radius: 11px;
    }

    /deep/.el-checkbox__inner::after {
      width: 6px;
      height: 11px;
      left: 7px;
      top: 2px;
    }

    /deep/ .el-checkbox__label {
      font-size: 16px;
    }

    div {
      color: #666;
    }
  }

  .DetailsCheck {
    /deep/.el-radio-button:first-child .el-radio-button__inner {
      border-radius: 20px 0 0 20px !important;
    }

    /deep/.el-radio-button:last-child .el-radio-button__inner {
      border-radius: 0 20px 20px 0;
    }
  }
}

.bgbox {
  width: 100%;
  height: 100%;
}

.rightOrder {
  width: 100%;
  // height: calc(100% - 66px);
  display: grid;
  grid-template-columns: 1fr 200px;
  flex-direction: column;

  .bigbox {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
  }

  .mainView {
    width: 100%;
    height: calc(100vh - 290px);

    // border-bottom: 1px solid #eaeaea;
    // flex: 1;
    overflow-y: auto;

    .hiddenTips {
      width: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      .tips {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: #bbe4ff;
        font-size: 28px;

        span {
          margin-top: 40px;
        }
      }
    }

    .selectTitle {
      display: grid;
      grid-template-columns: 60px 1fr 60px 40px 70px 80px 60px 60px 90px;
      padding: 10px;
      font-size: 16px;
      border-bottom: 1px solid #eaeaea;
      background: #339af0;
      color: #fff;
      position: sticky;
      top: 0px;
    }

    .selectItem {
      width: 100%;
      border-bottom: 1px solid #eaeaea;
      cursor: pointer;
      display: flex;
      align-items: center;

      .selectTop {
        // display: flex;
        // padding: 30px 9px 0;
        display: grid;
        grid-template-columns: 60px 1fr 60px 40px 70px 80px 60px 60px 90px;
        padding: 10px;
        align-items: center;
        font-size: 16px;
        color: rgb(102, 102, 102);

        .selectTopLeft {
          flex: 1;
          display: flex;
          align-items: center;
        }

        .selectNum {
          flex: 0 0 200px;
          display: flex;
          align-items: flex-end;
          justify-content: flex-end;
          margin-right: 9px;
        }
      }

      .selectBottom {
        display: flex;
        align-items: center;
        padding: 0 9px;
        color: #666;
        justify-content: space-between;
        margin: 10px 0;
        font-size: 14px;

        .selectLeftBottom {
          display: flex;
          align-items: center;
          color: #666;
        }

        /deep/ .el-input__suffix {
          top: -3px !important;
        }
      }

      .funcBtn {
        display: flex;
        justify-content: end;
        padding: 0 10px 10px;

        .funcBtnItem {
          min-width: 41px;
          border-radius: 30px;
          color: #fff;
          font-size: 16px;
          padding: 7px 10px;
          background: #0099ff;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-left: 20px;
        }

        // .funcBtnItem:nth-child(2) {
        //   margin-right: 200px;
        // }
      }
    }

    .selectItemCurrent {
      background: #edf8ff !important;
      border: 2px solid #0099ff;
    }
  }

  .mainViews {
    height: calc(100vh - 230px);
  }

  .mainFooter {
    height: 80px;
    border-top: 1px solid #eaeaea;
    width: 100%;
    background: #fff;
    border-radius: 0 0 20px 20px;
    flex: 0 0 auto;
    display: flex;
    flex-direction: column;

    .footerBottom {
      flex: 0 0 80px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 10px;

      .footerLeftDiv {
        height: 100%;
        display: flex;
        align-items: center;

        .footerLeftbutton {
          display: flex;
          align-items: center;

          div {
            cursor: pointer;
            max-width: 80px;
            min-width: 60px;
            margin: 0 5px 0 10px;
            height: 40px;
            background: #0099ff;
            box-shadow: 0px 2px 5px 0px rgba(0, 153, 255, 0.3);
            border-radius: 30px;
            font-size: 18px;
            color: #ffffff;
            line-height: 40px;
            text-align: center;
          }
        }
      }

      //  .gray{
      //      background: #7f8c8d;
      //   }
      .footerRightDiv {
        height: 100%;
        display: flex;
        align-items: center;

        .footerLeftDivCancel {
          max-width: 100px;
          min-width: 80px;
          cursor: pointer;
          height: 60px;
          background: #0099ff;
          box-shadow: 0px 2px 10px 0px rgba(254, 137, 47, 0.3);
          border-radius: 38px;
          font-size: 18px;
          color: #ffffff;
          line-height: 60px;
          text-align: center;
          margin: 0 10px 0 0;
        }

        .rightBtn {
          cursor: pointer;
          // max-width: 100px;
          // min-width: 80px;
          margin: 0 10px;
          padding: 0 14px;
          height: 40px;
          background: #0099ff;
          box-shadow: 0px 2px 5px 0px rgba(0, 153, 255, 0.3);
          border-radius: 30px;
          font-size: 18px;
          color: #ffffff;
          line-height: 40px;
          text-align: center;
        }

        .grayBtn {
          cursor: pointer;
          // max-width: 100px;
          // min-width: 80px;
          margin: 0 10px;
          padding: 0 14px;
          height: 40px;
          background: #868e96;
          box-shadow: 0px 2px 5px 0px rgba(0, 153, 255, 0.3);
          border-radius: 30px;
          font-size: 18px;
          color: #ffffff;
          line-height: 40px;
          text-align: center;
        }

        .rightBtnnumber {
          position: absolute;
          top: 0;
          right: 0;
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background: #c0392b;
          color: #fff;
          font-size: 10px;
          display: block;
        }
      }
    }

    /deep/.el-checkbox__inner {
      width: 22px;
      height: 22px;
      border-radius: 11px;
    }

    /deep/.el-checkbox__inner::after {
      width: 6px;
      height: 11px;
      left: 7px;
      top: 2px;
    }

    /deep/ .el-checkbox__label {
      font-size: 16px;
    }

    /deep/.el-checkbox__input.is-indeterminate .el-checkbox__inner::before {
      left: 0px;
      top: 10px;
    }
  }

  .menuDetails {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 90px 50px 50px 50px 50px 50px 50px 50px 50px 50px 1fr 50px;
    // flex-direction: column;
    overflow: auto;
    grid-row-gap: 8px;
    // grid-column-gap: 20px;
    padding: 10px 10px 0;
    border-left: 1px solid #eee;
    height: 100%;

    .menuDataOneRight {
      text-align: center;
      // margin-right: 108px;
      background: #ffffff;
      border-radius: 6px;
      border: 1px solid #eaeaea;
      // margin: 0px 0 2px 0;
      padding-bottom: 4px;
      padding-top: 2px;
    }

    .menuDataTwo {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      grid-row-gap: 4px;
      grid-column-gap: 4px;
      justify-content: center;
      margin: 10px 0;
      align-items: center;

      .menuDataTwoItem {
        background: #ffffff;
        border-radius: 6px;
        border: 1px solid #eaeaea;
        text-align: center;
        padding-top: 4px;
        padding-bottom: 10px;
        font-size: 10px;
      }
    }

    .menuDataThreeAndFour {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-row-gap: 6px;
      grid-column-gap: 6px;
      margin: 0 0 10px;

      .menuDataThreeAndFourItem {
        height: 40px;
        border-radius: 6px;
        border: 1px solid #eaeaea;
        text-align: center;
        font-size: 16px;
        padding: 2px 0 0 0;
      }
    }

    .menuDataFiveRight {
      width: 100%;
      // background: #e7e8f1;
      border-radius: 6px;
      border: 1px solid #eaeaea;
      text-align: center;
      padding-top: 4px;
      padding-bottom: 8px;
      // margin-bottom: 10px;
    }

    .menuDataSixRight {
      width: 100%;
      height: 40px;
      line-height: 40px;
      // background: #e7e8f1;
      border-radius: 6px;
      border: 1px solid #eaeaea;
      text-align: center;
      // padding-top: 4px;
    }
  }
}

.footerTop {
  display: grid;
  // 60px 1fr 60px 40px 80px 80px 60px 60px 100px
  grid-template-columns: 140px 1fr 104px 70px 80px 60px 60px 90px;
  height: 60px;
  align-items: center;
  padding: 0 10px;
  border-top: 1px solid #eaeaea;
  border-bottom: 1px solid #eaeaea;
  width: 100%;
  font-size: 16px;

  /deep/.el-radio__inner {
    width: 12px;
    height: 12px;
    border-radius: 18px;
  }

  .bz {
    flex: 1;
  }

  .beizhu {
    margin: 0 10px;
    background: #eeeeee;
    color: #666666;
    height: 56px;
    line-height: 56px;
    text-indent: 10px;
    border-radius: 6px;
  }

  .allPrice {
    padding: 10px 20px;
    border-left: 1px solid #eaeaea;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 24px;

    .totalPrice {
      height: 100%;
      color: #fe8d30;
    }
  }
}

.disable {
  background: #bdc3c7 !important;
  box-shadow: none;
}

.addFoodTTT {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  width: 100%;
  display: flex;
  justify-content: center;
}

/deep/.el-dialog__body {
  padding: 0 25px 25px !important;
  width: 100%;
}

/deep/.el-dialog__footer {
  width: 100%;
}

.addFoodMain {
  height: 66px;
  display: flex;
  width: 100%;
  justify-content: center;
  margin-top: 36px;
  align-items: center;
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #666666;

  /deep/.el-input__inner {
    font-size: 18px;
    border: none;
    width: 200px !important;
    padding: 0;
    background: #eee;
    text-align: center;
  }
}

.psdMain {
  display: flex;
  width: 100%;
  justify-content: center;
  margin-top: 36px;
  align-items: center;
  font-size: 24px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #666666;

  /deep/.el-input__inner {
    font-size: 24px;
    border: none;
    width: 350px !important;
    padding: 0;
    background: #eee;
    text-align: center;
  }

  /deep/.el-form-item__error {
    font-size: 20px;
    margin-top: 10px;
  }

  /deep/.el-form-item__content {
    margin: 0 !important;
    width: 100%;
    display: flex;
    justify-content: center;
  }
}

.timeStop {
  width: 100%;

  // 计时里的单选框
  /deep/.el-radio__inner {
    width: 36px;
    height: 36px;
    border-radius: 18px;
  }

  /deep/.el-radio {
    display: flex;
    align-items: center;
  }

  /deep/.el-radio__label {
    font-size: 16px !important;
    font-weight: 500;
    color: #666666;
  }

  /deep/ .el-radio__input.is-checked .el-radio__inner::after {
    content: '';
    width: 18px;
    height: 9px;
    border: 1px solid white;
    border-top: transparent;
    border-right: transparent;
    text-align: center;
    display: block;
    position: absolute;
    top: 10px;
    left: 8px;
    transform: rotate(-45deg);
    border-radius: 0px;
    background: none;
  }

  /deep/.el-radio-group {
    width: 90%;
    display: flex;
    justify-content: space-around;
    margin: 54px 0 0 0;
  }
}

.startTimeAndEndTime {
  width: 100%;
  margin-top: 54px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .timeItem {
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #666666;
    width: 80%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 30px;
    align-items: center;

    span:nth-child(1) {
      margin-right: 60px;
    }

    .timeED {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: calc(100% - 170px);

      span:nth-child(1) {
        font-size: 32px;
        color: #fe852f;
        margin: 0;
      }
    }
  }
}

.messageMain {
  padding: 0 20px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  .messageItem {
    width: 100%;
    background: #fff;
    border-radius: 20px;
    padding: 16px 40px;
    color: #666;
    margin: 10px 0;

    .titleMessage {
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
    }

    .messageContent {
      font-size: 18px;
      font-weight: 600;
    }
  }
}

.takeOutFoodMain {
  height: 66px;
  display: flex;
  width: 100%;
  justify-content: center;
  margin-top: 36px;
  align-items: center;
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #666666;

  /deep/.el-input__inner {
    font-size: 18px;
    border: none;
    width: 400px !important;
    padding: 0;
    background: #eee;
    text-align: center;
  }
}

.leftMoney {
  display: flex;

  .moneyItem {
    display: flex;
    flex-direction: column;
    margin-right: 100px;
    align-items: flex-start;

    span:nth-child(1) {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #666666;
    }

    span:nth-child(2) {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #fe852f;
      margin-top: 10px;
    }
  }
}

.discountReason {
  /deep/.el-input__inner {
    font-size: 18px;
    border: none;
    width: 100% !important;
    background: #eee;
    text-indent: 20px;
  }

  /deep/.el-input--suffix {
    margin: 0;
  }

  .returnFoodMain {
    height: 66px;
    display: flex;
    width: 100%;
    margin-top: 16px;
    align-items: center;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #666666;
  }
}

.soft_keyboard {
  width: 45%;
  display: flex;
  flex-wrap: wrap;
  margin-top: 16px;

  .keyItem {
    width: 91px;
    height: 66px;
    background: #eeeeee;
    border-radius: 6px;
    text-align: center;
    color: #666;
    line-height: 66px;
    font-size: 18px;
    margin-right: 20px;
    margin-bottom: 16px;
    cursor: pointer;
  }
}

.LDReason {
  padding: 0 20px;

  /deep/.el-input__inner {
    font-size: 18px;
    border: none;
    width: 100% !important;
    background: #eee;
  }

  .returnTitle {
    margin: 20px 0 10px;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #666666;
  }

  .returnItem {
    display: flex;
    flex-wrap: wrap;
    height: 200px;
    overflow: hidden;

    div {
      margin: 5px 20px 5px 0;
      font-size: 18px;
      width: 190px;
      height: 66px;
      background: #eeeeee;
      border-radius: 6px;
      line-height: 66px;
      text-align: center;
      cursor: pointer;
      overflow: hidden; //超出的文本隐藏
      text-overflow: ellipsis; //溢出用省略号显示
      white-space: nowrap; //溢出不换行
    }
  }

  .returnFoodMain {
    height: 66px;
    display: flex;
    width: 100%;
    margin-top: 16px;
    align-items: center;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #666666;
  }

  .guestMain {
    margin-top: 20px;
  }
}

.ldFooter {
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;

  // 计时里的单选框
  /deep/.el-radio__inner {
    width: 22px;
    height: 22px;
    border-radius: 11px;
  }

  /deep/.el-radio {
    display: flex;
    align-items: center;
  }

  /deep/.el-radio__label {
    font-size: 16px !important;
    font-weight: 500;
    color: #666666;
  }

  /deep/ .el-radio__input.is-checked .el-radio__inner::after {
    content: '';
    width: 10px;
    height: 6px;
    border: 1px solid white;
    border-top: transparent;
    border-right: transparent;
    text-align: center;
    display: block;
    position: absolute;
    top: 4px;
    left: 4px;
    transform: rotate(-45deg);
    border-radius: 0px;
    background: none;
  }

  /deep/.el-radio-group {
    width: 40%;
    display: flex;
    justify-content: space-around;
  }
}

.changeReason {
  padding: 0 20px;

  /deep/.el-input__inner {
    font-size: 18px;
    border: none;
    width: 100% !important;
    background: #eee;
  }

  .returnTitle {
    margin: 20px 0 10px;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #666666;
  }

  .returnItem {
    display: flex;
    flex-wrap: wrap;
    height: 200px;

    div {
      margin: 5px 20px 5px 0;
      font-size: 18px;
      width: 190px;
      height: 66px;
      background: #eeeeee;
      border-radius: 6px;
      line-height: 66px;
      text-align: center;
      cursor: pointer;
      overflow: hidden;
    }
  }

  .returnFoodMain {
    height: 66px;
    display: flex;
    width: 100%;
    margin-top: 16px;
    align-items: center;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #666666;
  }

  .guestMain {
    margin-top: 20px;
  }
}

.remarkflex {
  display: grid;
  grid-template-columns: 140px 1fr 100px;
  justify-content: center;
  align-items: center;
  margin: 30px 0px 10px;

  .returnTitle {
    margin: 20px 10px 10px;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #666666;
    text-align: right;
  }

  .returnItem {
    display: flex;
    flex-wrap: wrap;

    div {
      margin: 5px 20px 5px 0;
      font-size: 18px;
      width: 190px;
      height: 66px;
      background: #eeeeee;
      border-radius: 6px;
      line-height: 66px;
      text-align: center;
      cursor: pointer;
      overflow: hidden;
    }
  }

  .returnFoodMain {
    height: 66px;
    display: flex;
    // width: 100%;
    margin-top: 16px;
    align-items: center;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #666666;
  }

  /deep/.el-input__inner {
    font-size: 18px;
    border: none;
    width: 400px !important;
    padding: 0;
    background: #eee;
    text-align: center;
  }

  .returnGift {
    border-radius: 30px;
    width: 100px;
    background: -webkit-gradient(linear, 0 0, 0 100%, from(#ffbe34), to(#fe812f)) !important;
    border: none;
    font-size: 18px;
    height: 60px;
    font-weight: 400;
    letter-spacing: 8px;
    line-height: 60px;
    text-align: center;
    color: #fff;
  }

  .returnNote {
    font-size: 18px;
    font-weight: 400;
    text-align: center;
  }
}

.returnReason {
  margin: 0px 20px 10px;

  .returnTitle {
    margin: 20px 10px 10px;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #666666;
  }

  .returnItem {
    display: flex;
    flex-wrap: wrap;

    div {
      margin: 5px 20px 5px 0;
      font-size: 18px;
      width: 190px;
      height: 66px;
      background: #eeeeee;
      border-radius: 6px;
      line-height: 66px;
      text-align: center;
      cursor: pointer;
      overflow: hidden;
    }
  }

  .returnFoodMain {
    height: 66px;
    display: flex;
    // width: 100%;
    margin-top: 16px;
    align-items: center;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #666666;

    /deep/.el-input__inner {
      font-size: 18px;
      border: none;
      width: 200px !important;
      padding: 0;
      background: #eee;
      text-align: center;
    }
  }
}

.returnItemCurrent {
  background: #0099ff !important;
  color: #fff;
}

.paytableunder {
  display: flex;
  justify-content: center;

  .underLeft {
    display: flex;
    flex-direction: column;
  }

  /deep/.el-input__inner {
    width: 100% !important;
  }

  .underMiddle {
    width: 247px;
    height: 140px;
    background: #eeeeee;
    border-radius: 6px;
    padding: 20px;
    margin: 16px 0 0 10px;

    div:nth-child(1) {
      margin-bottom: 20px;
      font-size: 18px;
    }

    div:nth-child(2) {
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #0099ff;
    }
  }

  .Collection {
    width: 160px;
    height: 140px;
    background: linear-gradient(225deg, #ffbe34 0%, #fe812f 100%);
    box-shadow: 0px 2px 10px 0px rgba(254, 137, 47, 0.3);
    border-radius: 6px;
    color: #fff;
    text-align: center;
    line-height: 140px;
    font-size: 18px;
    cursor: pointer;
    margin: 16px 0 0 10px;
  }
}

.payMethods {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  padding: 0 25px;

  .methodItem {
    width: 160px;
    height: 100px;
    background: #eeeeee;
    border-radius: 6px;
    font-size: 18px;
    color: #666;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 10px 10px 0 0;
    cursor: pointer;
  }

  .methodItem:nth-child(5n + 5) {
    margin: 10px 0 0 0;
  }

  .methodItem:nth-child(1) {
    margin: 10px 10px 0 10px;
  }

  .methodItem:nth-child(6) {
    margin: 10px 10px 0 10px;
  }

  .methodItem:nth-child(11) {
    margin: 10px 10px 0 10px;
  }
}

.discountflag {
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  div {
    margin: 5px 20px 5px 0;
    font-size: 18px;
    width: 190px;
    height: 66px;
    background: #eeeeee;
    border-radius: 6px;
    line-height: 66px;
    text-align: center;
    cursor: pointer;
  }
}

.allPrices {
  margin-left: 5px;
  color: #c0392b;
  font-size: 16px;
}

.discountType {
  width: 16px;
  height: 16px;
  line-height: 16px;
  background: #f0932b;
  text-align: center;
  border-radius: 100%;
  color: #fff;
  font-size: 10px;
}

.discountText {
  display: grid;
  grid-template-columns: 1fr 1fr;

  .discountTxt {
    display: grid;
    grid-template-columns: 140px 1fr;
    grid-row-gap: 40px;
    align-items: center;
    margin-top: 20px;

    /deep/ .el-input__inner {
      border: 2px solid #eee;
      width: 200px !important;
      font-size: 18px;
      padding-left: 10px;
    }
  }

  .boldText {
    font-size: 18px;
    font-weight: 400;
  }

  .discountRemark {
    margin-top: 20px;
  }

  .discounttextarea {
    margin-top: 20px;
  }
}

.singleTitle {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
  align-items: center;

  .minus {
    border: 1px solid #eee;
    padding: 10px 16px;
    margin-right: 20px;
    border-radius: 6px;
  }

  .add {
    border: 1px solid #67c23a;
    padding: 10px 16px;
    margin-right: 20px;
    border-radius: 6px;
    color: #fff;
    background: #67c23a;
  }
}

.singleMain {
  // display: grid;
  // grid-template-columns: repeat(4, 25%);
  // grid-row-gap: 25px;
  // grid-column-gap: 25px;
  display: flex;
  justify-content: space-around;
  border: 1px solid #eee;
  height: 500px;

  .singleBox {
    border: 1px solid #eee;
  }

  .singleBoxtotal {
    display: grid;
    grid-template-columns: 1fr 60px 60px 80px;
    justify-content: center;
    align-items: center;
    padding: 14px 10px;
    font-size: 14px;
    background: #74b9ff;
    color: #fff;

    div:nth-child(1) {
      text-align: center;
    }
  }
}

/deep/ .el-radio__label {
  font-size: 16px !important;
  font-weight: 500;
}
</style>

<style lang="scss" scoped>
/deep/.el-input__inner {
  border: none;
  width: 70px !important;
  padding: 0;
  // line-height: 0 !important;
  background: transparent;
}

/deep/.el-drawer {
  background: rgba(0, 0, 0, 0.3);
  width: 800px !important;

  .el-drawer__header > :first-child {
    width: 100%;
    display: flex;
    justify-content: center;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #fe852f;
    margin-top: 45px;
  }
}

/deep/.el-drawer__body {
  padding-bottom: 20px;
}

/deep/.el-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  // margin-top: 6vh !important;
  // margin-bottom: 6vh !important;
  overflow: auto;

  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  /*height:600px;*/
  max-height: calc(100% - 30px);
  max-width: calc(100% - 30px);
}

/deep/ .el-dialog__header {
  margin-top: 50px !important;
}

.jiezhang {
  /deep/.el-dialog {
    display: flex;
    flex-direction: column;
    // margin: 0 !important;
    margin-top: 3vh !important;
    margin-bottom: 6vh !important;
    overflow: auto;

    // position: absolute;
    // top: 50%;
    // left: 50%;
    // transform: translate(-50%, -50%);
    /*height:600px;*/
    // max-height: calc(100% - 30px);
    // max-width: calc(100% - 30px);
  }

  /deep/ .el-dialog__header {
    margin-top: 20px !important;
  }

  /deep/.el-dialog .el-dialog__body {
    flex: 1;
    overflow: auto;
    max-height: 690px;
  }
}

/deep/.el-dialog .el-dialog__body {
  flex: 1;
  overflow: auto;
}

/deep/.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #88abda;
  color: #fff;
}

/deep/ .el-table__body tr.current-row > td.el-table__cell {
  background-color: #88abda;
  color: #fff;
}

.selectItem {
  /deep/.el-checkbox {
    width: 30px;
    height: 30px;

    .el-checkbox__inner {
      width: 22px;
      height: 22px;
      border-radius: 11px;

      &::after {
        width: 6px;
        height: 11px;
        left: 7px;
        top: 2px;
      }
    }
  }
}

.beizhu {
  /deep/.el-input__inner {
    width: 80% !important;
    height: 40px;
  }
}

.dialogname {
  height: 33px;
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #666666;
  line-height: 33px;
  margin: 10px 0;
}

.dialoginput {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: 0 auto;
  border: 1px solid #bdc3c7;
  border-radius: 6px;
  background: #eeeeee;
  color: #666666;
  padding: 0 10px;
  // margin-bottom: 20px;
  font-size: 18px;

  /deep/.el-input__inner {
    width: 100% !important;
    padding: 0;
    line-height: 40px !important;
    height: 40px !important;
  }

  /deep/ .el-input--suffix {
    margin-bottom: 0;
  }
}

.printSelect {
  display: flex;
  align-items: center;
  justify-content: center;

  .PDateName {
    border: 1px solid #666;
    width: 200px;
    height: 30px;
    margin-left: 20px;

    /deep/.el-input__inner {
      // border: none;
      width: 200px !important;
      height: 30px;
      line-height: 30px;
      padding: 0 10px;
      // line-height: 0 !important;
      background: transparent;
    }

    /deep/ .el-input--suffix {
      margin-bottom: 0;
    }
  }
}

.singleDialog {
  /deep/ .el-dialog__header {
    margin-top: 20px !important;
  }

  /deep/ .el-dialog {
    width: 800px;
    max-width: 100%;
  }

  /deep/ .el-table .success-row {
    background: #409eff;
    color: #fff;
  }

  /deep/ .el-table .error-row {
    background: #bdc3c7;
    color: #7f8c8d;
  }

  // /deep/ .el-table {    overflow: visible !important;}
}

.singleMore {
  .label {
    display: grid;
    grid-template-columns: 200px 1fr;
    grid-column-gap: 20px;
    grid-row-gap: 20px;
    align-items: center;
    margin-top: 20px;
  }

  .name {
    text-align: right;
    font-size: 18px;
    font-weight: 400;
  }

  .el-input {
    width: 100px;
    height: 40px;
    line-height: 40px;
    margin-right: 10px;
  }

  /deep/ .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 100px !important;
    padding-left: 10px;
    border-radius: 8px;
    border: 1px solid #eee;

    &:focus {
      border: 1px solid #0099ff;
    }
  }
}
</style>
